import React, { useState, useEffect, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Confetti from 'react-confetti';
import {
    Box, Container, Typography, Paper, Button, CircularProgress, Alert, Snackbar,
    Radio, RadioGroup, FormControlLabel, FormControl, FormLabel,
    Checkbox, TextField, MenuItem, Select,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Slider, Rating, InputLabel, Tooltip, Grid, FormGroup, FormHelperText, Stepper,
    Step,
    StepLabel,
    useTheme,
    useMediaQuery,
    OutlinedInput,
    InputAdornment,
    Card,
    CardContent

} from '@mui/material';
import { DateTimePicker , PickersDay } from '@mui/x-date-pickers';
import sendParticipantToSentry from '../../utils/sendParticipantToSentry';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import API_CONFIG, { getApiUrl } from '../../config/api';
import QuestionRenderer from '../../components/survey/QuestionRenderer';
import { uploadFile } from '../../services/fileService';
import ImageIcon from '@mui/icons-material/Image';
import {
    ArrowBack,
    ArrowForward,
    KeyboardArrowLeft as PrevIcon,
    Send,
    Phone as PhoneIcon
} from '@mui/icons-material';
import { alpha, darken } from '@mui/material/styles';
import { getRankingItems, reorderRankingItems } from '../../utils/ranking';
import LogicEvaluationService from '../../services/LogicEvaluationService';
// import { useSurvey } from '../../contexts/SurveyContext';
import ThankYouScreen from '../../components/survey/ThankYouScreen';
import { setClarityUser, sendClarityEvent ,setClarityResponder} from '../../utils/clarity';
// ...existing code...
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
// ...existing code...



const SurveyForm = () => {
    // const { surveyData } = useSurvey(); 
    // const { surveyId, userId } = surveyData || {};
    const { shortId } = useParams();
    const { surveyId } = useParams();
    const [searchParams] = useSearchParams();
    const resumeResponderId = searchParams.get('responder_id');
    // const [, setSurveyId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [survey, setSurvey] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [logicRules, setLogicRules] = useState([]);
    const [logicLoadError, setLogicLoadError] = useState(null);
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('');
    const [rankItems, setRankItems] = useState({});
    const [responder, setResponder] = useState(null);
    const startTime = useRef(new Date());
    const [displayMode, setDisplayMode] = useState('all'); // 'all' or 'single'
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(-1); // Start with email screen
    const [validationErrors, setValidationErrors] = useState({});
    const [isTyping, setIsTyping] = useState(false);
    const [hasStartedTyping, setHasStartedTyping] = useState(false);
    const [timeSpentPerQuestion, setTimeSpentPerQuestion] = useState({});
    const [questionStartTimes, setQuestionStartTimes] = useState({});
    const [activeQuestionId, setActiveQuestionId] = useState(null);
    const [surveyTheme, setSurveyTheme] = useState(null);
    const [surveyLayout, setSurveyLayout] = useState('classic');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); const [hasWelcomePage, setHasWelcomePage] = useState(false);
    const [emailRequired, setEmailRequired] = useState(true); // Default to true for backward compatibility
    const [showConfetti, setShowConfetti] = useState(false);
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const logicEvaluationService = new LogicEvaluationService();
    const logicEvaluation = logicEvaluationService.evaluateRules(logicRules, answers, questions);
    const questionVisibility = logicEvaluationService.getQuestionVisibility(questions, logicEvaluation);
    const visibleQuestions = questions.filter(question => questionVisibility[String(question.id)] !== false);
    const lastVisibleQuestionIndex = visibleQuestions.length
        ? questions.findIndex(question => question.id === visibleQuestions[visibleQuestions.length - 1].id)
        : -1;
    const findVisibleQuestionIndex = (startIndex, direction) => {
        for (let index = startIndex; index >= 0 && index < questions.length; index += direction) {
            if (questionVisibility[String(questions[index].id)] !== false) return index;
        }
        return -1;
    };


    // Add this helper function at the top of the file
    const decodeHTMLEntities = (text) => {
        if (!text) return '';
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    };

    const [tempFiles, setTempFiles] = useState({}); // Add this state for storing files temporarily

    useEffect(() => {
        const initialRankingItems = {};
        questions.forEach((question, index) => {
            if (question.type === 'ranking') {
                const questionId = question.id || `temp-question-${index}`;
                const items = getRankingItems(question);
                if (items.length > 0) {
                    initialRankingItems[questionId] = items;
                }
            }
        });
        setRankItems(initialRankingItems);
    }, [questions]);

    // Handle window resize for confetti
    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


  



    // Generate a unique browser fingerprint
    const generateBrowserFingerprint = () => {
        const userAgent = navigator.userAgent;
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const colorDepth = window.screen.colorDepth;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const language = navigator.language;

        // Create a fingerprint string combining various browser properties
        const fingerprintString = `${userAgent}|${screenWidth}x${screenHeight}|${colorDepth}|${timezone}|${language}`;

        // Create a simple hash of the fingerprint string
        let hash = 0;
        for (let i = 0; i < fingerprintString.length; i++) {
            const char = fingerprintString.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }

        return hash.toString();
    };

    // Add Clarity helper + sent flags
const startedEventSentRef = useRef(false);
const submitEventSentRef = useRef(false);
const submissionInProgressRef = useRef(false);



    useEffect(() => {
        if (!surveyId) return;

        const initializeResponder = async () => {
            if (!surveyId) {
                console.error('No survey ID provided');
                return;
            }

            try {
                // Get user's IP and location
                let systemInfo = {
                    browser: 'Unknown',
                    os: 'Unknown',
                    user_ip: '',
                    location: '',
                    fingerprint: generateBrowserFingerprint() // Add browser fingerprint
                };

                // Get IP address
                const ipResponse = await fetch('https://api.ipify.org?format=json');
                const ipData = await ipResponse.json();
                systemInfo.user_ip = ipData.ip;

                // Get location from IP
                try {
                    const locationResponse = await fetch(`https://ipapi.co/${ipData.ip}/json/`);
                    const locationData = await locationResponse.json();
                    systemInfo.location = locationData.city || 'Unknown';
                } catch (error) {
                    console.error('Error getting location:', error);
                }

                // Get browser info
                const userAgent = navigator.userAgent;
                if (userAgent.indexOf("Chrome") > -1) systemInfo.browser = `Chrome-${systemInfo.fingerprint}`;
                else if (userAgent.indexOf("Safari") > -1) systemInfo.browser = `Safari-${systemInfo.fingerprint}`;
                else if (userAgent.indexOf("Firefox") > -1) systemInfo.browser = `Firefox-${systemInfo.fingerprint}`;
                else if (userAgent.indexOf("Edge") > -1) systemInfo.browser = `Edge-${systemInfo.fingerprint}`;
                else if (userAgent.indexOf("MSIE") > -1) systemInfo.browser = `Internet Explorer-${systemInfo.fingerprint}`;
                else systemInfo.browser = `Unknown-${systemInfo.fingerprint}`;

                // Get OS info
                if (userAgent.indexOf("Win") > -1) systemInfo.os = "Windows";
                else if (userAgent.indexOf("Mac") > -1) systemInfo.os = "MacOS";
                else if (userAgent.indexOf("Linux") > -1) systemInfo.os = "Linux";
                else if (userAgent.indexOf("Android") > -1) systemInfo.os = "Android";
                else if (userAgent.indexOf("iOS") > -1) systemInfo.os = "iOS";

                console.log('System Info:', systemInfo); // Debug log

                const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.RESPONSES.INITIALIZE_RESPONDER), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        survey_id: surveyId,
                        ...(resumeResponderId ? { responder_id: resumeResponderId } : {}),
                        browser: systemInfo.browser,
                        os: systemInfo.os,
                        user_ip: systemInfo.user_ip,
                        location: systemInfo.location,
                        status: 'started'
                    })
                });

                const data = await response.json();
                console.log('Initialize response:', data); // Debug log

                if (response.ok && data.status === 'success') {
                    setResponder(data.responder);
                    if (data.responder.email) {
                        setEmail(data.responder.email);
                    }
                } else {
                    throw new Error(data.message || 'Failed to initialize responder');
                }
            } catch (error) {
                // Track exception during initialization
                sendParticipantToSentry({
                    email: 'not-provided-yet@example.com',
                    surveyId: surveyId,
                    surveyName: 'Loading Survey',
                    error: error,
                    additionalData: {
                        browser: navigator.userAgent,
                        fingerprint: generateBrowserFingerprint()
                    },
                    context: 'form-initialization-exception',
                    functionName: 'initializeResponder' // Add the actual function name
                });
                console.error('Error initializing responder:', error);
                setError('Failed to initialize form. Please try again.');
            }
        };

        initializeResponder();
    }, [surveyId, resumeResponderId]);

    useEffect(() => {
    if (responder && surveyId && !startedEventSentRef.current) {
        startedEventSentRef.current = true;

         setClarityResponder(surveyId, responder.id);

        sendClarityEvent('form_started', {
            surveyId: surveyId,
            responderId: responder.id,
            user_ip: responder.user_ip || '',
            
            timestamp: new Date().toISOString()
        });
        console.log('clarity form started for:', responder);
        
    }
}, [responder]);

    // Update the time tracking effect to use a longer interval
    useEffect(() => {
        let intervalId;
        if (activeQuestionId && questionStartTimes[activeQuestionId]) {
            intervalId = setInterval(() => {
                const timeSpent = Math.floor((Date.now() - questionStartTimes[activeQuestionId]) / 1000);
                setTimeSpentPerQuestion(prev => ({
                    ...prev,
                    [activeQuestionId]: timeSpent
                }));
            }, 5000); // Update time every 5 seconds instead of every second
        }
        return () => clearInterval(intervalId);
    }, [activeQuestionId, questionStartTimes]);

    const validateAnswer = (question, value) => {
        if (!question) return { isValid: true, errorMessage: '' };

        let isValid = true;
        let errorMessage = '';

        // First check if value exists for required fields
        const hasValue = value && (typeof value !== 'string' || value.trim()) && (!Array.isArray(value) || value.length > 0);

        if (question.required && !hasValue) {
            isValid = false;
            errorMessage = question.errorMessage || 'This field is required';
            return { isValid, errorMessage };
        }

        // Only validate format/length if there's a value
        if (hasValue) {
            // Handle different question types
            if (question.type === 'number') {
                const numValue = value ? value.toString() : '';
                const minValue = parseInt(question.minValue, 10);
                const maxValue = parseInt(question.maxValue, 10);

                // Check if the number length is within bounds
                if (!isNaN(minValue) && numValue.length < minValue) {
                    isValid = false;
                    errorMessage = question.errorMessage || `Number must be at least ${minValue} digits long`;
                }
                else if (!isNaN(maxValue) && numValue.length > maxValue) {
                    isValid = false;
                    errorMessage = question.errorMessage || `Number must not exceed ${maxValue} digits`;
                }
            }
            else if (question.type === 'email') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    isValid = false;
                    errorMessage = question.errorMessage || 'Please enter a valid email address';
                }
            }
            else if (question.type === 'phone') {
                const phoneRegex = /^\+?[\d\s-()]{10,}$/;
                if (!phoneRegex.test(value)) {
                    isValid = false;
                    errorMessage = question.errorMessage || 'Please enter a valid phone number';
                }
            }
            else if (question.type === 'website') {
                const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
                if (!urlRegex.test(value)) {
                    isValid = false;
                    errorMessage = question.errorMessage || 'Please enter a valid website URL';
                }
            }
            else if (question.type === 'address') {
                // For address questions, validate ZIP code format if provided
                if (typeof value === 'object' && value.zip) {
                    const zipRegex = /^\d+$/; // Only numbers allowed
                    if (!zipRegex.test(value.zip.trim())) {
                        isValid = false;
                        errorMessage = question.errorMessage || 'ZIP code should only contain numbers';
                    }
                }
            }
            else if (typeof value === 'string') {
                // Handle minLength and maxLength validation for text fields
                const minLength = question.minLength !== undefined ? parseInt(question.minLength, 10) : NaN;
                const maxLength = question.maxLength !== undefined ? parseInt(question.maxLength, 10) : NaN;

                if (!isNaN(minLength) && value.length < minLength) {
                    isValid = false;
                    errorMessage = question.errorMessage || `Minimum length should be ${minLength} characters`;
                }
                else if (!isNaN(maxLength) && value.length > maxLength) {
                    isValid = false;
                    errorMessage = question.errorMessage || `Maximum length should be ${maxLength} characters`;
                }
            }
        }

        return { isValid, errorMessage };
    };

    // Update the handleAnswer function
    const handleAnswer = async (questionId, value) => {
        setActiveQuestionId(questionId);

        // Set the answer immediately without waiting
        setAnswers(prev => ({
            ...prev,
            [questionId]: value
        }));

        // Find the current question to validate
        const currentQuestion = questions.find(q => q.id === questionId);
        if (currentQuestion) {
            // Run validation
            const validation = validateAnswer(currentQuestion, value);

            if (!validation.isValid) {
                // Set validation error
                setValidationErrors(prev => ({
                    ...prev,
                    [questionId]: validation.errorMessage
                }));
            } else {
                // Clear validation error if valid
                setValidationErrors(prev => ({
                    ...prev,
                    [questionId]: null
                }));
            }
        }

        // Initialize question time if not already set
        if (!questionStartTimes[questionId]) {
            setQuestionStartTimes(prev => ({
                ...prev,
                [questionId]: Date.now()
            }));
        }

        // Debounce the API call
        const debouncedApiCall = setTimeout(async () => {
            if (responder) {
                try {
                    // Create system info object with browser fingerprint
                    const systemInfo = {
                        browser: `${navigator.userAgent.indexOf("Chrome") > -1 ? "Chrome" :
                            navigator.userAgent.indexOf("Safari") > -1 ? "Safari" :
                                navigator.userAgent.indexOf("Firefox") > -1 ? "Firefox" :
                                    navigator.userAgent.indexOf("Edge") > -1 ? "Edge" :
                                        navigator.userAgent.indexOf("MSIE") > -1 ? "Internet Explorer" : "Unknown"}-${generateBrowserFingerprint()}`,
                        os: navigator.userAgent.indexOf("Win") > -1 ? "Windows" :
                            navigator.userAgent.indexOf("Mac") > -1 ? "MacOS" :
                                navigator.userAgent.indexOf("Linux") > -1 ? "Linux" :
                                    navigator.userAgent.indexOf("Android") > -1 ? "Android" :
                                        navigator.userAgent.indexOf("iOS") > -1 ? "iOS" : "Unknown",
                        user_ip: responder?.user_ip || '',
                        location: responder?.location || '',
                        fingerprint: generateBrowserFingerprint()
                    };

                    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.RESPONSES.SUBMIT), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            responder_id: responder.id,
                            status_update: true,
                            status: hasStartedTyping ? 'pending' : 'started',
                            questionId: questionId,
                            answer: value,
                            updateProgress: true,
                            systemInfo: systemInfo // Add system info with fingerprint
                        })
                    });

                    if (!response.ok) {
                        console.error('Failed to update question progress');
                    }

                    if (!hasStartedTyping) {
                        setHasStartedTyping(true);
                    }
                } catch (error) {
                    console.error('Error updating progress:', error);
                }
            }
        }, 1000); // Delay API call by 1 second

        // Cleanup previous timeout
        return () => clearTimeout(debouncedApiCall);
    };

    const handleQuestionChange = (oldQuestionId, newQuestionId) => {
        if (oldQuestionId && questionStartTimes[oldQuestionId]) {
            handleQuestionBlur(oldQuestionId);
        }
        if (newQuestionId) {
            handleQuestionFocus(newQuestionId);
        }
    };
    const handleQuestionFocus = (questionId) => {
        setActiveQuestionId(questionId);
        // Only set start time if there isn't one already
        if (!questionStartTimes[questionId]) {
            setQuestionStartTimes(prev => ({
                ...prev,
                [questionId]: Date.now() - ((timeSpentPerQuestion[questionId] || 0) * 1000)
            }));
        }
    };

    const handleQuestionBlur = (questionId) => {
        if (questionStartTimes[questionId]) {
            const timeSpent = Math.floor((Date.now() - questionStartTimes[questionId]) / 1000);
            // Don't add to previous time, just set the total time
            setTimeSpentPerQuestion(prev => ({
                ...prev,
                [questionId]: timeSpent
            }));
            // Clear the start time when leaving the question
            setQuestionStartTimes(prev => {
                const newTimes = { ...prev };
                delete newTimes[questionId];
                return newTimes;
            });
            setActiveQuestionId(null);
        }
    };

    useEffect(() => {
        if (surveyLayout === 'classic' || currentQuestionIndex < 0 || !questions[currentQuestionIndex]) return;
        const currentQuestion = questions[currentQuestionIndex];
        if (questionVisibility[String(currentQuestion.id)] !== false) return;

        const nextIndex = findVisibleQuestionIndex(currentQuestionIndex + 1, 1);
        const destinationIndex = nextIndex >= 0
            ? nextIndex
            : findVisibleQuestionIndex(currentQuestionIndex - 1, -1);
        if (destinationIndex >= 0) {
            handleQuestionChange(currentQuestion.id, questions[destinationIndex].id);
            setCurrentQuestionIndex(destinationIndex);
        } else {
            setCurrentQuestionIndex(-1);
        }
    }, [currentQuestionIndex, questions, questionVisibility, surveyLayout]);


    const handleEmailChange = async (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);

        // Clear email validation error when user starts typing
        if (validationErrors.email) {
            setValidationErrors(prev => ({
                ...prev,
                email: null
            }));
        }

        if (responder && newEmail) {
            try {
                // Create system info object with browser fingerprint
                const systemInfo = {
                    browser: `${navigator.userAgent.indexOf("Chrome") > -1 ? "Chrome" :
                        navigator.userAgent.indexOf("Safari") > -1 ? "Safari" :
                            navigator.userAgent.indexOf("Firefox") > -1 ? "Firefox" :
                                navigator.userAgent.indexOf("Edge") > -1 ? "Edge" :
                                    navigator.userAgent.indexOf("MSIE") > -1 ? "Internet Explorer" : "Unknown"}-${generateBrowserFingerprint()}`,
                    os: navigator.userAgent.indexOf("Win") > -1 ? "Windows" :
                        navigator.userAgent.indexOf("Mac") > -1 ? "MacOS" :
                            navigator.userAgent.indexOf("Linux") > -1 ? "Linux" :
                                navigator.userAgent.indexOf("Android") > -1 ? "Android" :
                                    navigator.userAgent.indexOf("iOS") > -1 ? "iOS" : "Unknown",
                    user_ip: responder?.user_ip || '',
                    location: responder?.location || '',
                    fingerprint: generateBrowserFingerprint()
                };

                console.log('Updating email:', {
                    responder_id: responder.id,
                    status_update: true,
                    status: 'started',
                    email: newEmail,
                    systemInfo: systemInfo
                });

                const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.RESPONSES.SUBMIT), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        responder_id: responder.id,
                        status_update: true,
                        status: 'started',
                        email: newEmail,
                        systemInfo: systemInfo // Add system info with fingerprint
                    })
                });

                const data = await response.json();
                console.log('Email update response:', data);

                if (!response.ok) {
                    console.error('Failed to update responder email');
                }
            } catch (error) {
                console.error('Error updating responder email:', error);
            }
        }
    };


    const handleNextQuestion = (e) => {
        if (e) {
            e.preventDefault(); // Prevent form submission
        }

        // Validate current field before proceeding
        if (currentQuestionIndex === -1) {
            // Validate email on email screen
            if (emailRequired && !email.trim()) {
                // Set email validation error
                setValidationErrors(prev => ({
                    ...prev,
                    email: 'Email is required'
                }));
                return; // Don't proceed if email is empty
            }
            // Validate email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRequired && !emailRegex.test(email.trim())) {
                // Set email format validation error
                setValidationErrors(prev => ({
                    ...prev,
                    email: 'Please enter a valid email address'
                }));
                return; // Don't proceed if email format is invalid
            }
            // Clear email validation error if valid
            setValidationErrors(prev => ({
                ...prev,
                email: null
            }));
        } else if (currentQuestionIndex >= 0) {
            // Validate current question
            const currentQuestion = questions[currentQuestionIndex];
            if (currentQuestion) {
                let currentAnswer = answers[currentQuestion.id];

                // Special handling for address questions
                if (currentQuestion.type === 'address') {
                    const addressFields = ['street', 'city', 'state', 'zip', 'country'];
                    const addressValues = addressFields.map(field =>
                        answers[`${currentQuestion.id}_${field}`]
                    ).filter(value => value && value.trim());

                    // For required address questions, all fields must be filled
                    if (currentQuestion.required) {
                        const missingFields = [];
                        addressFields.forEach(field => {
                            const fieldValue = answers[`${currentQuestion.id}_${field}`];
                            if (!fieldValue || !fieldValue.trim()) {
                                missingFields.push(field.charAt(0).toUpperCase() + field.slice(1));
                            }
                        });
                        
                        if (missingFields.length > 0) {
                            setValidationErrors(prev => ({
                                ...prev,
                                [currentQuestion.id]: `Please fill in all required fields: ${missingFields.join(', ')}`
                            }));
                            return; // Don't proceed if required fields are empty
                        }
                        
                        // Validate ZIP code format
                        const zipValue = answers[`${currentQuestion.id}_zip`];
                        if (zipValue && zipValue.trim()) {
                            const zipRegex = /^\d+$/;
                            if (!zipRegex.test(zipValue.trim())) {
                                setValidationErrors(prev => ({
                                    ...prev,
                                    [currentQuestion.id]: 'ZIP code should only contain numbers'
                                }));
                                return; // Don't proceed if ZIP code is invalid
                            }
                        }
                    } else {
                        // For optional address questions, consider it valid if at least one field is filled
                        const hasValidAnswer = addressValues.length > 0;
                        if (hasValidAnswer) {
                            // Still validate ZIP code format if provided
                            const zipValue = answers[`${currentQuestion.id}_zip`];
                            if (zipValue && zipValue.trim()) {
                                const zipRegex = /^\d+$/;
                                if (!zipRegex.test(zipValue.trim())) {
                                    setValidationErrors(prev => ({
                                        ...prev,
                                        [currentQuestion.id]: 'ZIP code should only contain numbers'
                                    }));
                                    return; // Don't proceed if ZIP code is invalid
                                }
                            }
                        }
                    }
                } else {
                    // Use the validateAnswer function for all other question types including multiple-choice
                    const validation = validateAnswer(currentQuestion, currentAnswer);
                    if (!validation.isValid) {
                        // Set the validation error message
                        setValidationErrors(prev => ({
                            ...prev,
                            [currentQuestion.id]: validation.errorMessage
                        }));
                        return; // Don't proceed if validation fails
                    }
                }

                // Clear validation error if valid
                setValidationErrors(prev => ({
                    ...prev,
                    [currentQuestion.id]: null
                }));
            }
        }

        if (currentQuestionIndex >= 0 && logicEvaluation.endSurvey) {
            handleSubmit({ preventDefault: () => {}, logicEnd: true });
            return;
        }

        const jumpTarget = currentQuestionIndex >= 0
            ? logicEvaluationService.getJumpTarget(logicEvaluation)
            : null;
        const jumpIndex = jumpTarget
            ? questions.findIndex(question => String(question.id) === String(jumpTarget))
            : -1;
        const nextIndex = jumpIndex >= 0 && questionVisibility[String(questions[jumpIndex].id)] !== false
            ? jumpIndex
            : findVisibleQuestionIndex(currentQuestionIndex + 1, 1);

        if (nextIndex >= 0) {
            const currentQuestion = questions[currentQuestionIndex];
            const nextQuestion = questions[nextIndex];
            if (currentQuestion && nextQuestion) {
                handleQuestionChange(currentQuestion.id, nextQuestion.id);
            }
            setCurrentQuestionIndex(nextIndex);
        } else {
            handleSubmit({ preventDefault: () => {} });
        }
    };

    const handlePrevQuestion = () => {
        const previousIndex = findVisibleQuestionIndex(currentQuestionIndex - 1, -1);
        if (currentQuestionIndex > 0 && previousIndex >= 0) {
            const currentQuestion = questions[currentQuestionIndex];
            const prevQuestion = questions[previousIndex];
            if (currentQuestion && prevQuestion) {
                handleQuestionChange(currentQuestion.id, prevQuestion.id);
            }
            setCurrentQuestionIndex(previousIndex);
        } else if (currentQuestionIndex >= 0) {
            // Going back from first question to email page
            setCurrentQuestionIndex(-1);
        }
    };

    const handleSubmit = async (e) => {
        
        e.preventDefault();
        if (submissionInProgressRef.current) return;
        submissionInProgressRef.current = true;
         sendClarityEvent('form_submission_started', {
                        surveyId: surveyId,
                        responderId: responder?.id || null,
                      
                    });
        try {
            if (logicEvaluation.errors.length > 0) {
                throw new Error(`Survey logic is invalid: ${logicEvaluation.errors.map(item => item.error).filter(Boolean).join('; ')}`);
            }
            // --- Validate email requirement first ---
            if (emailRequired && (!email || !email.trim())) {
                setValidationErrors(prev => ({
                    ...prev,
                    email: 'Email is required'
                }));
                
                // Scroll to email field if it exists
                const emailField = document.querySelector('input[type="email"]');
                if (emailField) {
                    emailField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    emailField.focus();
                }
                submissionInProgressRef.current = false;
                return;
            }
            
            // Validate email format if email is provided and required
            if (emailRequired && email && email.trim()) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email.trim())) {
                    setValidationErrors(prev => ({
                        ...prev,
                        email: 'Please enter a valid email address'
                    }));
                    
                    // Scroll to email field if it exists
                    const emailField = document.querySelector('input[type="email"]');
                    if (emailField) {
                        emailField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        emailField.focus();
                    }
                    submissionInProgressRef.current = false;
                    return;
                }
            }
            
            // Clear email validation error if valid
            setValidationErrors(prev => ({
                ...prev,
                email: null
            }));

            // --- Validate required questions before submission ---
            const missing = {};
            questions.forEach((q, questionIndex) => {
                if (questionVisibility[String(q.id)] === false ||
                    (e?.logicEnd && questionIndex > currentQuestionIndex)) return;
                // API returns required as 1 or 0; treat 1 as required
                const isRequired = q.required === 1 || q.required === true;
                if (isRequired) {
                    let hasAnswer = true;

                    if (q.type === 'matrix') {
                        // matrix answers stored per cell like `${q.id}_${row}_${col}`
                        const matrixKeys = Object.keys(answers).filter(k => k.startsWith(`${q.id}_`));
                        hasAnswer = matrixKeys.some(k => {
                            const v = answers[k];
                            return v !== undefined && v !== null && String(v).trim() !== '';
                        });
                    } else if (q.type === 'address') {
                        // Special handling for address questions
                        const addressFields = ['street', 'city', 'state', 'zip', 'country'];
                        
                        if (q.required) {
                            // For required address questions, all fields must be filled
                            const missingFields = [];
                            addressFields.forEach(field => {
                                const fieldValue = answers[`${q.id}_${field}`];
                                if (!fieldValue || !fieldValue.trim()) {
                                    missingFields.push(field.charAt(0).toUpperCase() + field.slice(1));
                                }
                            });
                            
                            if (missingFields.length > 0) {
                                hasAnswer = false;
                                missing[q.id] = `Please fill in all required fields: ${missingFields.join(', ')}`;
                            } else {
                                // Validate ZIP code format
                                const zipValue = answers[`${q.id}_zip`];
                                if (zipValue && zipValue.trim()) {
                                    const zipRegex = /^\d+$/;
                                    if (!zipRegex.test(zipValue.trim())) {
                                        hasAnswer = false;
                                        missing[q.id] = 'ZIP code should only contain numbers';
                                    }
                                }
                            }
                        } else {
                            // For optional address questions, consider it valid if at least one field is filled
                            const addressValues = addressFields.map(field =>
                                answers[`${q.id}_${field}`]
                            ).filter(value => value && value.trim());
                            
                            hasAnswer = addressValues.length > 0;
                            
                            // Still validate ZIP code format if provided
                            if (hasAnswer) {
                                const zipValue = answers[`${q.id}_zip`];
                                if (zipValue && zipValue.trim()) {
                                    const zipRegex = /^\d+$/;
                                    if (!zipRegex.test(zipValue.trim())) {
                                        hasAnswer = false;
                                        missing[q.id] = 'ZIP code should only contain numbers';
                                    }
                                }
                            }
                        }
                    } else {
                        const ans = answers[q.id];

                        if (ans === undefined || ans === null) hasAnswer = false;
                        else if (typeof ans === 'string' && ans.trim() === '') hasAnswer = false;
                        else if (Array.isArray(ans) && ans.length === 0) hasAnswer = false;

                        // Also run validation for format/length checks
                        if (hasAnswer) {
                            const validation = validateAnswer(q, ans);
                            if (!validation.isValid) {
                                missing[q.id] = validation.errorMessage;
                                hasAnswer = false; // Treat as invalid
                            }
                        }
                    }

                    if (!hasAnswer) {
                        if (!missing[q.id]) { // Only set if not already set by validation
                            missing[q.id] = q.errorMessage || 'This field is required';
                        }
                    }
                }
            });

            if (Object.keys(missing).length > 0) {
                // set per-question errors only — don't set global `error` which hides the form
                setValidationErrors(prev => ({ ...prev, ...missing }));

                // Scroll to first missing question if present
                const firstMissingId = Object.keys(missing)[0];
                const el = document.querySelector(`[data-question-id="${firstMissingId}"]`);
                if (el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                // Stop submission
                submissionInProgressRef.current = false;
                return;
            }

            // --- End validation ---
            const fileUploads = await Promise.all(
                Object.entries(tempFiles).filter(([questionId]) => {
                    const questionIndex = questions.findIndex(question => question.id === questionId);
                    return questionIndex >= 0 && questionVisibility[String(questionId)] !== false &&
                        (!e?.logicEnd || questionIndex <= currentQuestionIndex);
                }).map(async ([questionId, file]) => {
                    try {
                        const fileUrl = await uploadFile(file, responder.id, surveyId, questionId);
                        return [questionId, fileUrl];
                    } catch (error) {
                        // Enhanced error reporting for file upload failures
                        sendParticipantToSentry({
                            email: email || 'anonymous@user.com',
                            surveyId: surveyId,
                            surveyName: survey?.name || 'Unknown Survey',
                            error: error,
                            additionalData: {
                                questionId: questionId,
                                fileName: file.name,
                                fileSize: file.size,
                                fileType: file.type,
                                formUrl: window.location.pathname
                            },
                            context: 'file-upload-error',
                            functionName: 'handleSubmit'
                        });
                        throw new Error(`Failed to upload file for question ${questionId}: ${error.message}`);
                    }
                })
            );

            // Update answers with file URLs
            const updatedAnswers = { ...answers };
            fileUploads.forEach(([questionId, fileUrl]) => {
                updatedAnswers[questionId] = fileUrl;
            });

            // Calculate final time for current question
            if (currentQuestionIndex >= 0) {
                const currentQuestionId = questions[currentQuestionIndex].id;
                handleQuestionBlur(currentQuestionId);
            }

            const formattedAnswers = questions.filter((question, questionIndex) =>
                questionVisibility[String(question.id)] !== false &&
                (!e?.logicEnd || questionIndex <= currentQuestionIndex)
            ).map(question => {
                let answer = '';

                if (question.type === 'address') {
                    const addressParts = ['street', 'city', 'state', 'zip', 'country'];
                    const addressData = {};
                    addressParts.forEach(part => {
                        const key = `${question.id}_${part}`;
                        if (updatedAnswers[key]) {
                            addressData[part] = updatedAnswers[key];
                        }
                    });
                    answer = JSON.stringify(addressData);
                } else if (question.type === 'matrix') {
                    const matrixAnswers = {};
                    Object.keys(updatedAnswers).forEach(key => {
                        if (key.startsWith(question.id)) {
                            const rowIndex = key.split('_')[1];
                            matrixAnswers[rowIndex] = updatedAnswers[key];
                        }
                    });
                    answer = JSON.stringify(matrixAnswers);
                } else if (question.type === 'ranking') {
                    const rankedItems = updatedAnswers[question.id];
                    if (Array.isArray(rankedItems)) {
                        answer = JSON.stringify(rankedItems);
                    } else {
                        const rankData = {};
                        Object.keys(updatedAnswers).forEach(key => {
                            if (key.startsWith(question.id)) {
                                const index = key.split('_')[1];
                                rankData[index] = updatedAnswers[key];
                            }
                        });
                        answer = JSON.stringify(rankData);
                    }
                } else {
                    answer = updatedAnswers[question.id] || '';
                }

                return {
                    questionId: question.id,
                    answer: answer,
                    timeSpent: timeSpentPerQuestion[question.id] || 0
                };
            }).filter(answer => answer.answer !== '');

            // Create system info object with browser fingerprint
            const systemInfo = {
                browser: `${navigator.userAgent.indexOf("Chrome") > -1 ? "Chrome" :
                    navigator.userAgent.indexOf("Safari") > -1 ? "Safari" :
                        navigator.userAgent.indexOf("Firefox") > -1 ? "Firefox" :
                            navigator.userAgent.indexOf("Edge") > -1 ? "Edge" :
                                navigator.userAgent.indexOf("MSIE") > -1 ? "Internet Explorer" : "Unknown"}-${generateBrowserFingerprint()}`,
                os: navigator.userAgent.indexOf("Win") > -1 ? "Windows" :
                    navigator.userAgent.indexOf("Mac") > -1 ? "MacOS" :
                        navigator.userAgent.indexOf("Linux") > -1 ? "Linux" :
                            navigator.userAgent.indexOf("Android") > -1 ? "Android" :
                                navigator.userAgent.indexOf("iOS") > -1 ? "iOS" : "Unknown",
                user_ip: responder?.user_ip || '',
                location: responder?.location || '',
                fingerprint: generateBrowserFingerprint()
            };

            const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.RESPONSES.SUBMIT), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    survey_id: surveyId,
                    responder_id: responder.id,
                    respondent_email: email,
                    response_data: formattedAnswers,
                    startTime: startTime.current.toISOString(),
                    status: 'completed', // Add status in submission
                    systemInfo: systemInfo // Add system info with fingerprint
                })
            });
            const data = await response.json();

            if (response.ok && data.status === 'success') {
                // After successful submission, initialize a new responder
                setSubmitted(true); setShowConfetti(true);

                 if (!submitEventSentRef.current) {
                    submitEventSentRef.current = true;
                      setClarityResponder(surveyId, responder?.id || null);

                    sendClarityEvent('form_submitted', {
                        surveyId: surveyId,
                        responderId: responder?.id || null,
                        timestamp: new Date().toISOString()
                    });
                }

                // Stop confetti after 8 seconds (longer duration)
                setTimeout(() => {
                    setShowConfetti(false);
                }, 8000);

            } else {
                throw new Error(data.message || 'Failed to submit response');
            }
        } catch (error) {
            submissionInProgressRef.current = false;
            sendParticipantToSentry({
                email: email || 'anonymous@user.com',
                surveyId: surveyId,
                surveyName: survey?.name || 'Unknown Survey',
                error: error,
                additionalData: {
                    answersCount: Object.keys(answers).length,
                    questionsCount: questions.length,
                    formStatus: 'submission_error',
                    timeSpent: Math.floor((Date.now() - startTime.current) / 1000),
                    userIp: responder?.user_ip,
                    fingerprint: generateBrowserFingerprint(),
                    browser: navigator.userAgent,
                    responderId: responder?.id || 'unknown',
                    errorMessage: error.message,
                    errorStack: error.stack,
                    errorName: error.name,
                    networkStatus: navigator.onLine ? 'online' : 'offline',
                    formData: JSON.stringify(Object.keys(answers)) // Only send keys to avoid sending sensitive data
                },
                context: 'form-submission-exception',
                functionName: 'handleSubmit' // Add the actual function name
            });
            setError(error.message);
        }
    };




    useEffect(() => {
        setLogicLoadError(null);
        setLogicRules([]);
        // console.log('surveydata:', surveyData);


        //  console.log("Survey ID:", surveyId);
        // console.log("User ID:", userId);

        const fetchSurvey = async () => {
            try {
                // First fetch survey details to get theme and layout
                console.log("Survey ID being sent to API:", surveyId);
                const surveyResponse = await fetch(`${getApiUrl(API_CONFIG.ENDPOINTS.SURVEYS.GET)}?id=${surveyId}&source=survey_form`);

                // const apiUrl = `${window.location.origin}/surveyslack-apis/APIs/get_survey.php?id=${surveyId}&user_id=${userId}`;
                // const surveyResponse = await fetch(apiUrl);
                if (!surveyResponse.ok) throw new Error('Failed to fetch survey details');
                const surveyData = await surveyResponse.json();

                if (surveyData.status === 'success' && surveyData.survey) {
                    const surveyDetails = {
                        id: surveyData.survey.id,
                        name: surveyData.survey.name,
                        description: surveyData.survey.description,
                        form_settings: surveyData.survey.form_settings,
                    };            // Set survey theme and layout
                    console.log('Survey details:', surveyDetails);

                    // Check if welcome page should be shown based on any welcome content
                    const shouldShowWelcome = surveyDetails.form_settings && (
                        surveyDetails.form_settings.welcome_title ||
                        surveyDetails.form_settings.welcome_text ||
                        surveyDetails.form_settings.welcome_description ||
                        surveyDetails.form_settings.welcome_image
                    );

                    setHasWelcomePage(shouldShowWelcome);
                    console.log('Should show welcome page:', shouldShowWelcome, surveyDetails.form_settings);

                    // Set email requirement from survey settings
                    const isEmailRequired = surveyDetails.form_settings?.email_required !== false; // Default to true if not set
                    setEmailRequired(isEmailRequired);            // Set initial question index based on welcome page presence
                    if (shouldShowWelcome) {
                        setCurrentQuestionIndex(-2); // Welcome page
                    } else {
                        setCurrentQuestionIndex(-1); // Always show email page (required or optional)
                    }

                    setSurvey(surveyDetails);
                    // Provide default theme values when surveyTheme is null or incomplete (e.g., AI-generated surveys)
                    const defaultTheme = {
                        name: 'default',
                        accentColor: '#1976d2',
                        textColor: '#000000',
                        bg: '#ffffff',
                        borderColor: '#e0e0e0',
                        inputBg: '#ffffff'
                    };
                    
                    const surveyTheme = surveyData.survey.theme;
                    if (!surveyTheme || typeof surveyTheme !== 'object') {
                        setSurveyTheme(defaultTheme);
                    } else {
                        // Merge with defaults to ensure all required properties exist
                        setSurveyTheme({
                            ...defaultTheme,
                            ...surveyTheme
                        });
                    }
                    setSurveyLayout(surveyData.survey.layout || 'classic');
                    console.log('Survey details:', survey);

                    // setSurvey({
                    //     id: surveyData.survey.id,
                    //     name: surveyData.survey.name,

                    //     description: 'Please answer the following questions'
                    // });
                }

                const questionsUrl = `${getApiUrl(API_CONFIG.ENDPOINTS.QUESTIONS.LIST)}?survey_id=${surveyId}`;
                console.log('Questions API URL:', questionsUrl);

                const response = await fetch(questionsUrl, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error('Failed to fetch data');
                const data = await response.json();
                console.log('Response data:', data);

                if (data.status === 'success' && data.questions) {
                    const formattedQuestions = data.questions
                        .sort((a, b) => a.order_index - b.order_index)
                        .map(q => {
                            try {



                                // First, extract and normalize options into a standard format
                                const processedOptions = (() => {
                                    console.log('Processing options for question:', q.id, q.question_type);

                                    // Add special handling for multiple-choice and checkboxes
                                    if (q.question_type === 'multiple-choice' || q.question_type === 'checkboxes') {
                                        // Create hardcoded options map for specific questions with known options
                                        const knownOptions = {
                                            "10534": ["Direct", "Indirect", "Written", "Verbal", "Other"],
                                            "67167": ["Very well", "Well", "Somewhat", "Not well", "Not at all"]
                                        };

                                        // If we have hardcoded options for this question, use them
                                        if (knownOptions[q.id]) {
                                            console.log(`Using hardcoded options for question ${q.id}`);
                                            return knownOptions[q.id];
                                        }
                                    }

                                    // Case 1: If options is a string, try to parse it
                                    if (typeof q.options === 'string') {
                                        try {
                                            const parsed = JSON.parse(q.options || '{}');

                                            if (parsed.options && Array.isArray(parsed.options)) {
                                                console.log(`Found options array in 'options' key for question ${q.id}`);
                                                return parsed.options;
                                            } else if (parsed.choices && Array.isArray(parsed.choices)) {
                                                console.log(`Found options array in 'choices' key for question ${q.id}`);
                                                return parsed.choices;
                                            } else if (Array.isArray(parsed)) {
                                                console.log(`Found direct array in JSON string for question ${q.id}`);
                                                return parsed;
                                            }
                                        } catch (e) {
                                            console.error(`Failed to parse options string for question ${q.id}:`, e);
                                            return [];
                                        }
                                    }
                                    // Case 2: If options is already an array, use it directly
                                    else if (Array.isArray(q.options)) {
                                        console.log(`Using direct array for question ${q.id}, length: ${q.options.length}`);
                                        return q.options;
                                    }
                                    // Case 3: If options is an object with options/choices property
                                    else if (q.options && typeof q.options === 'object') {
                                        if (q.options.options && Array.isArray(q.options.options)) {
                                            console.log(`Found options in q.options.options for question ${q.id}`);
                                            return q.options.options;
                                        } else if (q.options.choices && Array.isArray(q.options.choices)) {
                                            console.log(`Found options in q.options.choices for question ${q.id}`);
                                            return q.options.choices;
                                        }
                                    }

                                    // Check for choices property directly on question
                                    if (q.choices && Array.isArray(q.choices)) {
                                        console.log(`Found options in q.choices for question ${q.id}`);
                                        return q.choices;
                                    }

                                    // No default options, just return empty array
                                    console.warn(`No valid options found for question ${q.id}`);
                                    return [];
                                })();

                                // Special handling for image-choice type

                                // Extract extra fields from parsed options if present
                                let parsedOptionsObj = {};
                                if (typeof q.options === 'string') {
                                    try {
                                        const parsed = JSON.parse(q.options || '{}');
                                        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                                            parsedOptionsObj = parsed;
                                        }
                                    } catch (e) { }
                                } else if (q.options && typeof q.options === 'object' && !Array.isArray(q.options)) {
                                    parsedOptionsObj = q.options;
                                }

                                return {
                                    id: q.id,
                                    type: q.question_type,
                                    title: q.question_text,
                                    required: Boolean(q.required),
                                    options: processedOptions, // Store as main options array
                                    choices: processedOptions, // Store as choices too for compatibility
                                    rawOptions: q.options, // Keep original format for reference
                                    orderIndex: q.order_index,
                                    rows: q.rows || parsedOptionsObj.rows || [],
                                    columns: q.columns || parsedOptionsObj.columns || [],
                                    caption: q.caption !== undefined ? q.caption : (parsedOptionsObj.caption !== undefined ? parsedOptionsObj.caption : ''),
                                    placeholder: q.placeholder !== undefined ? q.placeholder : (parsedOptionsObj.placeholder !== undefined ? parsedOptionsObj.placeholder : ''),
                                    defaultValue: q.defaultValue !== undefined ? q.defaultValue : (parsedOptionsObj.defaultValue !== undefined ? parsedOptionsObj.defaultValue : ''),
                                    errorMessage: q.errorMessage !== undefined ? q.errorMessage : (parsedOptionsObj.errorMessage !== undefined ? parsedOptionsObj.errorMessage : ''),
                                    validation: q.validation || parsedOptionsObj.validation || '',
                                    minLength: q.minLength !== undefined ? q.minLength : (parsedOptionsObj.minLength !== undefined ? parsedOptionsObj.minLength : undefined),
                                    maxLength: q.maxLength !== undefined ? q.maxLength : (parsedOptionsObj.maxLength !== undefined ? parsedOptionsObj.maxLength : undefined),
                                    minValue: q.minValue !== undefined ? q.minValue : (parsedOptionsObj.minValue !== undefined ? parsedOptionsObj.minValue : undefined),
                                    maxValue: q.maxValue !== undefined ? q.maxValue : (parsedOptionsObj.maxValue !== undefined ? parsedOptionsObj.maxValue : undefined),
                                    allowOther: q.allowOther || parsedOptionsObj.allowOther,
                                    randomize: q.randomize || parsedOptionsObj.randomize,
                                    showValidation: q.showValidation !== undefined ? q.showValidation : (parsedOptionsObj.showValidation !== undefined ? parsedOptionsObj.showValidation : false),
                                    textFormat: q.textFormat || parsedOptionsObj.textFormat,
                                    config: q.config || parsedOptionsObj.config,
                                    subfields: q.subfields || parsedOptionsObj.subfields || [],
                                    enabledFields: q.enabledFields || parsedOptionsObj.enabledFields || {},
                                    allowMultipleSelection: q.question_type === 'image-choice' ? (q.options && q.options.allowMultipleSelection !== undefined ? q.options.allowMultipleSelection : parsedOptionsObj.allowMultipleSelection) : (q.allowMultipleSelection || parsedOptionsObj.allowMultipleSelection),
                                    maxFileSize: q.maxFileSize || parsedOptionsObj.maxFileSize,
                                    allowedFileTypes: q.allowedFileTypes || parsedOptionsObj.allowedFileTypes || []
                                };
                            } catch (parseError) {
                                console.error('Error parsing question:', parseError);
                                return null;
                            }
                        })
                        .filter(q => q !== null);

                    setQuestions(formattedQuestions);

                    try {
                        const logicResponse = await fetch(
                            `${getApiUrl(API_CONFIG.ENDPOINTS.LOGIC_RULES.LIST)}?survey_id=${encodeURIComponent(surveyId)}`
                        );
                        const logicData = await logicResponse.json();
                        if (!logicResponse.ok || logicData.status !== 'success') {
                            throw new Error(logicData.message || 'Unable to load survey logic rules');
                        }
                        setLogicRules((logicData.data?.rules || []).map(rule => ({
                            ...rule,
                            enabled: rule.enabled === true || rule.enabled === 1 || rule.enabled === '1'
                        })));
                    } catch (logicError) {
                        setLogicLoadError(logicError.message);
                        throw new Error(`Unable to load survey logic rules: ${logicError.message}`);
                    }

                    // Initialize answers with default values
                    const defaultAnswers = {};
                    formattedQuestions.forEach(question => {
                        if (question.defaultValue && question.defaultValue.trim() !== '') {
                            defaultAnswers[question.id] = question.defaultValue;
                        }
                    });
                    if (Object.keys(defaultAnswers).length > 0) {
                        setAnswers(defaultAnswers);
                    }

                    // Create a basic survey object from the first question's survey data
                    // const surveyData = data.questions[0]?.survey_id ? {
                    //     id: data.questions[0].survey_id,
                    //     name: surveyDetails.name,

                    //     description: 'Please answer the following questions'
                    // } : null;
                    // setSurvey(surveyData);
                } else {
                    throw new Error('No questions found');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSurvey();
    }, [surveyId]); const renderEmailField = () => {
        console.log('renderEmailField called, emailRequired:', emailRequired, 'hasWelcomePage:', hasWelcomePage);

        return (
            <Box sx={{
                width: '100%',
                maxWidth: '500px'
            }}>
                <Typography
                    variant="h3"
                    sx={{
                        mb: 2,
                        fontWeight: 700,
                        color: surveyTheme?.textColor || '#000',
                        fontSize: { xs: '1.75rem', sm: '2.25rem' },
                        lineHeight: 1.2
                    }}
                >
                    What's your email?
                </Typography>
                <Typography
                    variant="h6"
                    sx={{
                        mb: 4,
                        color: surveyTheme?.textColor || 'text.secondary',
                        fontWeight: 400,
                        fontSize: '1.125rem',
                        opacity: 0.8
                    }}
                >
                    {emailRequired 
                        ? "Please enter your email to continue" 
                        : "Please enter your email (optional)"}
                    {emailRequired && (
                        <Typography
                            component="span"
                            sx={{
                                color: 'error.main',
                                ml: 1
                            }}
                        >
                            *
                        </Typography>
                    )}
                </Typography>
                <TextField
                    fullWidth
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="name@example.com"
                    variant="outlined"
                    error={Boolean(validationErrors.email)}
                    helperText={validationErrors.email}
                    sx={{
                        mb: 4,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 0,
                            fontSize: '1.25rem',
                            py: 0.5,
                            border: 'none',
                            bgcolor: `${surveyTheme?.inputBg || 'transparent'} !important`,
                            color: surveyTheme?.textColor || 'text.primary',
                            '& fieldset': {
                                border: 'none',
                                borderBottom: '2px solid',
                                borderColor: surveyTheme?.borderColor || alpha('#000', 0.15),
                                borderRadius: 0
                            },
                            '&:hover fieldset': {
                                borderColor: alpha(surveyTheme?.accentColor || '#1976d2', 0.7),
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: surveyTheme?.accentColor || '#1976d2',
                                borderWidth: '2px'
                            },
                            '&.Mui-focused': {
                                bgcolor: `${surveyTheme?.inputBg || 'transparent'} !important`
                            },
                            '&.Mui-error fieldset': {
                                borderColor: 'error.main',
                                borderWidth: '2px'
                            },
                            '&.Mui-error:hover fieldset': {
                                borderColor: 'error.main',
                            }
                        },
                        '& .MuiInputBase-input': {
                            py: 2,
                            px: 0,
                            fontSize: '1.25rem',
                            fontWeight: 400,
                            color: surveyTheme?.textColor || 'text.primary',
                            '&::placeholder': {
                                color: alpha(surveyTheme?.textColor || '#000', 0.5)
                            }
                        },
                        '& .MuiFormHelperText-root': {
                            fontSize: '1rem',
                            mt: 1,
                            color: surveyTheme?.textColor || 'text.primary'
                        }
                    }}
                />
            </Box>
        );
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (logicLoadError) {
        return (
            <Container maxWidth="sm" sx={{ mt: 8 }}>
                <Alert severity="error">
                    This survey cannot safely start because its logic rules could not be loaded: {logicLoadError}
                </Alert>
            </Container>
        );
    }

    const renderQuestion = (question) => {
        const hasError = Boolean(validationErrors[question.id]);
        const errorMessage = validationErrors[question.id];

        // Get custom error message from question options or use default
        const getErrorMessage = (defaultMsg = 'This field is required') => {
            if (hasError) {
                // First try to get custom error message from question options
                const customErrorMessage = question.errorMessage ||
                    (question.options && question.options.errorMessage);
                return customErrorMessage || defaultMsg;
            }
            return '';
        };

        switch (question.type) {
             case 'text':
            case 'short-answer':
                return (
                    <Box sx={{ width: '100%', maxWidth: '600px' }}>
                        <TextField
                            fullWidth
                            placeholder={question.placeholder || 'Type your answer here...'}
                            value={answers[question.id] !== undefined ? answers[question.id] : (question.defaultValue || '')}
                            onChange={(e) => handleAnswer(question.id, e.target.value)}
                            onFocus={() => handleQuestionFocus(question.id)}
                            onBlur={() => handleQuestionBlur(question.id)}
                            error={hasError}
                            helperText={getErrorMessage()}
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 0,
                                    fontSize: '1.25rem',
                                    bgcolor: surveyTheme?.inputBg || 'transparent',
                                    color: surveyTheme?.textColor || 'text.primary',
                                    border: 'none',
                                    '& fieldset': {
                                        border: 'none',
                                        borderBottom: '2px solid',
                                        borderColor: surveyTheme?.borderColor || alpha('#000', 0.15),
                                        borderRadius: 0
                                    },
                                    '&:hover fieldset': {
                                        borderColor: alpha(surveyTheme?.accentColor || '#1976d2', 0.7),
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: surveyTheme?.accentColor || '#1976d2',
                                        borderWidth: '2px'
                                    },
                                     '&.Mui-focused': {
                                        bgcolor: `${surveyTheme?.inputBg || 'transparent'} !important`
                                    }
                                },
                                '& .MuiInputBase-input': {
                                    py: 2,
                                    px: 0,
                                    fontSize: '1.25rem',
                                    fontWeight: 400,
                                    color: surveyTheme?.textColor || 'text.primary',
                                    '&::placeholder': {
                                        color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                    }
                                },
                                '& .MuiFormHelperText-root': {
                                    color: surveyTheme?.textColor || 'text.primary'
                                }
                            }}
                        />
                    </Box>); case 'long-answer':
                return (
                    <Box sx={{ width: '100%', maxWidth: '700px' }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            required={question.required}
                            placeholder={question.placeholder || 'Type your detailed answer here...'}
                            value={answers[question.id] || ''}
                            onChange={(e) => handleAnswer(question.id, e.target.value)}
                            onFocus={() => handleQuestionFocus(question.id)}
                            onBlur={() => handleQuestionBlur(question.id)}
                            // error={hasError}
                            // helperText={getErrorMessage()}
                            // onBlur={() => handleQuestionBlur(question.id)}
                            error={Boolean(validationErrors[question.id])}
                            helperText={validationErrors[question.id]}
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                    fontSize: '1.125rem',
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                    color: surveyTheme?.textColor || 'text.primary',
                                    transition: 'all 0.2s ease',
                                    '& fieldset': {
                                        borderWidth: '2px',
                                        borderColor: surveyTheme?.borderColor || alpha('#000', 0.15)
                                    },
                                    '&:hover fieldset': {
                                        borderColor: alpha(surveyTheme?.accentColor || '#1976d2', 0.7),
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: surveyTheme?.accentColor || '#1976d2',
                                        borderWidth: '2px'
                                    },
                                    '&.Mui-focused': {
                                        transform: 'translateY(-1px)',
                                        boxShadow: `0 4px 12px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.2)}`
                                    }
                                },
                                '& .MuiInputBase-input': {
                                    py: 2.5,
                                    px: 2.5,
                                    fontSize: '1.125rem',
                                    fontWeight: 400,
                                    lineHeight: 1.5,
                                    color: surveyTheme?.textColor || 'text.primary',
                                    '&::placeholder': {
                                        color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                    }
                                },
                                '& .MuiFormHelperText-root': {
                                    color: surveyTheme?.textColor || 'text.primary'
                                }
                            }}
                        />
                    </Box>
                );

            case 'matrix':
                // Make sure rows and columns are properly extracted and never null
                let matrixRows = [];
                let matrixColumns = [];

                // First try direct properties (but these are empty in your case)
                if (question.rows && question.rows.length > 0) {
                    matrixRows = question.rows;
                }

                if (question.columns && question.columns.length > 0) {
                    matrixColumns = question.columns;
                }

                // Check the options array if rows/columns are still empty
                if ((matrixRows.length === 0 || matrixColumns.length === 0) && Array.isArray(question.options)) {
                    console.log('Extracting matrix data from options array');
                    const rows = [];
                    const columns = [];

                    let i = 0;
                    while (i < question.options.length) {
                        if (question.options[i] === 'id') {
                            i++; // Skip 'id'

                            if (i < question.options.length) {
                                const type = question.options[i];
                                i++; // Move to the value

                                if (i < question.options.length) {
                                    const value = question.options[i];

                                    if (type === 'rowvalue' || type === 'checkboxrow') {
                                        rows.push(value);
                                    } else if (type === 'columnvalue' || type === 'checkboxcolumn') {
                                        columns.push(value);
                                    }
                                }
                            }
                        }
                        i++;
                    }

                    if (rows.length > 0) matrixRows = rows;
                    if (columns.length > 0) matrixColumns = columns;
                }

                // If still empty, check the choices array (this is identical to your example data)
                if ((matrixRows.length === 0 || matrixColumns.length === 0) && Array.isArray(question.choices)) {
                    console.log('Extracting matrix data from choices array');
                    const rows = [];
                    const columns = [];

                    let i = 0;
                    while (i < question.choices.length) {
                        if (question.choices[i] === 'id') {
                            i++; // Skip 'id'

                            if (i < question.choices.length) {
                                const type = question.choices[i];
                                i++; // Move to the value

                                if (i < question.choices.length) {
                                    const value = question.choices[i];

                                    if (type === 'rowvalue' || type === 'checkboxrow') {
                                        rows.push(value);
                                    } else if (type === 'columnvalue' || type === 'checkboxcolumn') {
                                        columns.push(value);
                                    }
                                }
                            }
                        }
                        i++;
                    }

                    if (rows.length > 0) matrixRows = rows;
                    if (columns.length > 0) matrixColumns = columns;
                }

                // If still empty, check rawOptions.options
                if ((matrixRows.length === 0 || matrixColumns.length === 0) &&
                    question.rawOptions && Array.isArray(question.rawOptions.options)) {
                    console.log('Extracting matrix data from rawOptions.options');
                    const rows = [];
                    const columns = [];

                    let i = 0;
                    while (i < question.rawOptions.options.length) {
                        if (question.rawOptions.options[i] === 'id') {
                            i++; // Skip 'id'

                            if (i < question.rawOptions.options.length) {
                                const type = question.rawOptions.options[i];
                                i++; // Move to the value

                                if (i < question.rawOptions.options.length) {
                                    const value = question.rawOptions.options[i];

                                    if (type === 'rowvalue' || type === 'checkboxrow') {
                                        rows.push(value);
                                    } else if (type === 'columnvalue' || type === 'checkboxcolumn') {
                                        columns.push(value);
                                    }
                                }
                            }
                        }
                        i++;
                    }

                    if (rows.length > 0) matrixRows = rows;
                    if (columns.length > 0) matrixColumns = columns;
                }

                // Log what we found
                console.log('Final matrix configuration:', {
                    rows: matrixRows,
                    columns: matrixColumns
                });

                // Fallback to defaults if still empty
                if (matrixRows.length === 0) matrixRows = ['Row 1', 'Row 2', 'Row 3'];
                if (matrixColumns.length === 0) matrixColumns = ['Column 1', 'Column 2', 'Column 3'];

                // Now render the matrix with the extracted rows and columns
                return (
                    <>
                    <TableContainer component={Paper} elevation={0} sx={{
                        mb: 3,
                        backgroundColor: 'transparent',
                        '& .MuiTableCell-root': {
                            borderColor: surveyTheme?.borderColor || '#e0e0e0'
                        }
                    }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    {matrixColumns.map((column, index) => (
                                        <TableCell key={index} align="center" sx={{
                                            fontWeight: 'medium',
                                            color: surveyTheme?.textColor || '#000000'
                                        }}>
                                            {column}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {matrixRows.map((row, rowIndex) => (
                                    <TableRow key={rowIndex} sx={{
                                        '&:hover': {
                                            backgroundColor: alpha(surveyTheme?.accentColor || '#1976d2', 0.04)
                                        }
                                    }}>
                                        <TableCell sx={{
                                            fontWeight: 'medium',
                                            color: surveyTheme?.textColor || '#000000'
                                        }}>
                                            {row}
                                        </TableCell>
                                        {matrixColumns.map((_, colIndex) => (
                                            <TableCell key={colIndex} align="center">
                                                {Boolean(question.allowMultipleSelection) ? (
                                                    <Checkbox
                                                        checked={answers[`${question.id}_${rowIndex}_${colIndex}`] === 'true'}
                                                        onChange={(e) => {
                                                            handleAnswer(
                                                                `${question.id}_${rowIndex}_${colIndex}`,
                                                                e.target.checked.toString()
                                                            );
                                                        }}
                                                        sx={{
                                                            color: surveyTheme?.borderColor || '#e0e0e0',
                                                            '&.Mui-checked': {
                                                                color: surveyTheme?.accentColor || '#1976d2'
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <Radio
                                                        checked={answers[`${question.id}_${rowIndex}`] === colIndex.toString()}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                handleAnswer(`${question.id}_${rowIndex}`, colIndex.toString());
                                                            }
                                                        }}
                                                        sx={{
                                                            color: surveyTheme?.borderColor || '#e0e0e0',
                                                            '&.Mui-checked': {
                                                                color: surveyTheme?.accentColor || '#1976d2'
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {(hasError || question.caption) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage('Please select at least one option')}
                            </FormHelperText>
                        )}
                    </>
                    
                );

            case 'likert-scale':
                return (
                    <Box>
                        <FormControl component="fieldset" fullWidth>
                            <RadioGroup
                                row
                                value={answers[question.id] || ''}
                                onChange={(e) => handleAnswer(question.id, e.target.value)}
                            >
                                {[1, 2, 3, 4, 5].map((value) => (
                                    <FormControlLabel
                                        key={value}
                                        value={value.toString()}
                                        control={<Radio />}
                                        label={value.toString()}
                                        labelPlacement="bottom"
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                        {(hasError ) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage('Please select a rating')}
                            </FormHelperText>
                        )}
                    </Box>
                );

            case 'nps':
                return (
                    <Box sx={{ width: '100%', px: 2 }}>
                        <Slider
                            value={answers[question.id] || 0}
                            onChange={(_, value) => handleAnswer(question.id, value)}
                            step={1}
                            marks
                            min={0}
                            max={10}
                            valueLabelDisplay="auto"
                        />
                        {(hasError) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage('Please provide a score')}
                            </FormHelperText>
                        )}
                    </Box>
                );

            case 'ranking':
                const handleDragStart = (e, item) => {
                    e.dataTransfer.effectAllowed = 'move';
                    e.dataTransfer.setData('text/plain', String(item.id));
                    e.dataTransfer.setData('application/x-surveyslack-ranking-question', String(question.id));
                };

                const handleDragOver = (e) => {
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                };

                const handleDrop = (e, targetItem) => {
                    e.preventDefault();
                    const sourceQuestionId = e.dataTransfer.getData('application/x-surveyslack-ranking-question');
                    const draggedId = Number(e.dataTransfer.getData('text/plain'));
                    if (sourceQuestionId !== String(question.id) || !Number.isInteger(draggedId)) return;

                    const currentItems = rankItems[question.id] || [];
                    const reorderedItems = reorderRankingItems(currentItems, draggedId, targetItem.id);
                    if (reorderedItems === currentItems) return;
                    setRankItems(prev => ({
                        ...prev,
                        [question.id]: reorderedItems
                    }));
                    setAnswers(prev => ({
                        ...prev,
                        [question.id]: reorderedItems.map(item => item.text)
                    }));
                };

                return (
                    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
                        {(rankItems[question.id] || []).map((item, index) => (
                            <Box
                                key={item.id}
                                draggable
                                onDragStart={(e) => handleDragStart(e, item)}
                                onDragOver={handleDragOver}
                                onDrop={(e) => handleDrop(e, item)}
                                sx={{
                                    p: 2,
                                    mb: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    maxWidth: '100%',
                                    minWidth: 0,
                                    boxSizing: 'border-box',
                                    bgcolor: surveyTheme?.bg || 'background.paper',
                                    border: '2px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2,
                                    cursor: 'grab',
                                    overflow: 'hidden',
                                    '&:hover': {
                                        bgcolor: surveyTheme?.accentColor ? `${surveyTheme.accentColor}05` : 'action.hover',
                                        borderColor: surveyTheme.accentColor || 'divider'
                                    },
                                    '&:active': { cursor: 'grabbing' },
                                    '& .MuiTypography-root:last-child': {
                                        minWidth: 0,
                                        overflowWrap: 'anywhere'
                                    }
                                }}
                            >
                                <Box
                                    aria-hidden
                                    sx={{
                                        mr: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 32,
                                        height: 32,
                                        borderRadius: 1,
                                        color: surveyTheme?.textColor || 'text.secondary',
                                        bgcolor: 'transparent',
                                        fontSize: '1.25rem',
                                        cursor: 'grab',
                                        userSelect: 'none'
                                    }}
                                >
                                    ≡
                                </Box>
                                <Typography sx={{ mr: 2 }}>{index + 1}.</Typography>
                                <Typography>{item.text}</Typography>
                            </Box>
                        ))}

                    </Box>
                );

            case 'dropdown':
                const dropdownOptions = getRandomizedOptions(question);
                return (
                    <FormControl
                        fullWidth
                        error={hasError}
                        required={question.required}
                    >
                        <Select
                            value={answers[question.id] || ''}
                            onChange={(e) => handleAnswer(question.id, e.target.value)}
                            onFocus={() => handleQuestionFocus(question.id)}
                            onBlur={() => handleQuestionBlur(question.id)}
                            displayEmpty
                            size="medium"
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '& .MuiMenuItem-root': {
                                            color: surveyTheme?.textColor || 'text.primary',
                                            '&:hover': {
                                                bgcolor: alpha(surveyTheme?.accentColor || '#1976d2', 0.1)
                                            },
                                            '&.Mui-selected': {
                                                bgcolor: alpha(surveyTheme?.accentColor || '#1976d2', 0.2)
                                            }
                                        }
                                    }
                                }
                            }}
                            sx={{
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& .MuiSelect-select': {
                                    py: 1.5,
                                    color: surveyTheme?.textColor || 'text.primary'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '& .MuiSelect-icon': {
                                    color: surveyTheme?.textColor || 'text.primary'
                                }
                            }}
                        >
                            <MenuItem value="" disabled>
                                {question.placeholder || 'Select an option'}
                            </MenuItem>
                            {dropdownOptions?.map((option, idx) => (
                                <MenuItem key={idx} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                        {(hasError) && (
                            <FormHelperText error={hasError} sx={{ color: surveyTheme?.textColor || 'text.primary' }}>
                                {getErrorMessage()}
                            </FormHelperText>
                        )}
                    </FormControl>
                );

            case 'datetime':
                return (
                    
                   <Box>
  <LocalizationProvider dateAdapter={AdapterDateFns}>
  
<DateTimePicker
  value={answers[question.id] || null}
  onChange={(newValue) => handleAnswer(question.id, newValue)}
    slotProps={{
    textField: {
    //   fullWidth: true,
      error: hasError,
   
    //   sx: {
    //     "& .MuiOutlinedInput-root": {
    //       backgroundColor: "transparent", // REMOVE input box white
    //     },
       
    //   },
     sx: {
                                '& .MuiOutlinedInput-root': {
                                  bgcolor: `${surveyTheme?.inputBg || 'transparent'} !important`,
                                  color: surveyTheme?.textColor || 'text.primary',
                                  '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                  },
                                  '&:hover fieldset': {
                                    borderColor: alpha(surveyTheme?.accentColor || '#1976d2', 0.7)
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2',
                                    borderWidth: '2px'
                                  },
                                  // ensure focused input doesn't turn white
                                  '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'transparent'} !important`
                                  }
                                },
                                '& .MuiInputBase-input': {
                                  color: surveyTheme?.textColor || 'text.primary'
                                }
                              }
    },
}}
  renderInput={(params) => (
    <TextField
      {...params}
      fullWidth
      error={hasError}
      variant="outlined"
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "transparent",
        },
      }}
    />
  )}
  slots={{
    day: (props) => {
      const { selected, ...other } = props;
      return (
        <PickersDay
          {...other}
          sx={{
            ...(selected && {
              backgroundColor: "transparent",
              border: "1px solid",
              borderColor: "primary.main",
              color: "primary.main",
            }),
          }}
        />
      );
    },
  }}
 sx={{
  // Selected time value (hour/minute)
  "& .MuiClockNumber-root.Mui-selected": {
    backgroundColor: "transparent !important",
    border: "2px solid",
    borderColor: "primary.main",
    color: "primary.main",
  },

  // Remove the internal ripple background
  "& .MuiClockNumber-root.Mui-selected::after": {
    backgroundColor: "transparent !important",
  },

  // Clock center pin (optional)
  "& .MuiClock-pin": {
    backgroundColor: "primary.main",
  },

  // Clock pointer styles (optional)
  "& .MuiClockPointer-root": {
    backgroundColor: "primary.main",
  },

  "& .MuiClockPointer-thumb": {
    border: "2px solid primary.main",
  },
}}

/>
{/* <DateTimePicker
  value={answers[question.id] || null}
  onChange={(newValue) => handleAnswer(question.id, newValue)}
  slotProps={{
    textField: {
      fullWidth: true,
      error: hasError,
      variant: "outlined",
      sx: {
        "& .MuiOutlinedInput-root": {
          backgroundColor: "transparent", // REMOVE input box white
        },
      },
    },

    // REMOVE WHITE BACKGROUND FROM POPUP (calendar + clock)
    popper: {
      sx: {
        "& .MuiPaper-root": {
          backgroundColor: "transparent !important",
          boxShadow: "none !important",
        },
      },
    },
  }}

  // OVERRIDE INTERNAL PICKER BACKGROUNDS
  sx={{
    "& .MuiPickersLayout-root": {
      background: "transparent !important",
    },
    "& .MuiPickersCalendarHeader-root": {
      background: "transparent !important",
    },
    "& .MuiDayCalendar-monthContainer": {
      background: "transparent !important",
    },
    "& .MuiClock-root": {
      background: "transparent !important",
    },
    "& .MuiClockNumber-root": {
      background: "transparent !important",
    },
    "& .MuiPickersDay-root": {
      background: "transparent !important",
    },

    // selected time
    "& .MuiClockNumber-root.Mui-selected": {
      backgroundColor: "transparent !important",
      border: "2px solid",
      borderColor: "primary.main",
      color: "primary.main",
    },
  }}
/> */}



  </LocalizationProvider>
  {hasError && (
    <FormHelperText error={hasError} sx={{ mt: 1 }}>
      {getErrorMessage('Please select a date and time')}
    </FormHelperText>
  )}
</Box>
                   

                );

            case 'time':
                return (
                    <TextField
                        fullWidth
                        type="time"
                        value={answers[question.id] || ''}
                        onChange={(e) => handleAnswer(question.id, e.target.value)}
                        error={hasError}
                        helperText={getErrorMessage('Please select a time')}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 300 }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: surveyTheme?.textColor || 'text.primary'
                            },
                            '& .MuiFormHelperText-root': {
                                color: surveyTheme?.textColor || 'text.primary'
                            }
                        }}
                    />
                );

            case 'website':
                return (
                    <TextField
                        fullWidth
                        type="url"
                        placeholder="https://example.com"
                        value={answers[question.id] !== undefined ? answers[question.id] : (question.defaultValue || '')}
                        onChange={(e) => handleAnswer(question.id, e.target.value)}
                        error={hasError}
                        helperText={getErrorMessage('Please enter a valid website URL')}
                        InputProps={{
                            startAdornment: (
                                <Box component="span" sx={{ color: surveyTheme?.textColor || 'text.secondary', mr: 1 }}>
                                    🌐
                                </Box>
                            ),
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: surveyTheme?.textColor || 'text.primary',
                                '&::placeholder': {
                                    color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                }
                            },
                            '& .MuiFormHelperText-root': {
                                color: surveyTheme?.textColor || 'text.primary'
                            }
                        }}
                    />
                );

            case 'address':
                return (
                    <Box>
                        <TextField
                            fullWidth
                            placeholder="Street"
                            value={answers[`${question.id}_street`] || ''}
                            onChange={(e) => handleAnswer(`${question.id}_street`, e.target.value)}
                            sx={{ 
                                mb: 2,
                                '& .MuiOutlinedInput-root': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                    color: surveyTheme?.textColor || 'text.primary',
                                    '& fieldset': {
                                        borderColor: surveyTheme?.borderColor || 'divider'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: surveyTheme?.accentColor || '#1976d2'
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: surveyTheme?.accentColor || '#1976d2'
                                    }
                                },
                                '& .MuiInputBase-input': {
                                    color: surveyTheme?.textColor || 'text.primary',
                                    '&::placeholder': {
                                        color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                    }
                                }
                            }}
                        />
                        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                            <TextField
                                fullWidth
                                placeholder="City"
                                value={answers[`${question.id}_city`] || ''}
                                onChange={(e) => handleAnswer(`${question.id}_city`, e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '& fieldset': {
                                            borderColor: surveyTheme?.borderColor || 'divider'
                                        },
                                        '&:hover fieldset': {
                                            borderColor: surveyTheme?.accentColor || '#1976d2'
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: surveyTheme?.accentColor || '#1976d2'
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '&::placeholder': {
                                            color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                        }
                                    }
                                }}
                            />
                            <TextField
                                fullWidth
                                placeholder="State"
                                value={answers[`${question.id}_state`] || ''}
                                onChange={(e) => handleAnswer(`${question.id}_state`, e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '& fieldset': {
                                            borderColor: surveyTheme?.borderColor || 'divider'
                                        },
                                        '&:hover fieldset': {
                                            borderColor: surveyTheme?.accentColor || '#1976d2'
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: surveyTheme?.accentColor || '#1976d2'
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '&::placeholder': {
                                            color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                        }
                                    }
                                }}
                            />
                            <TextField
                                fullWidth
                                placeholder="ZIP code"
                                value={answers[`${question.id}_zip`] || ''}
                                onChange={(e) => {
                                    const zipValue = e.target.value;
                                    handleAnswer(`${question.id}_zip`, zipValue);
                                    
                                    // Validate ZIP code format in real-time
                                    if (zipValue && zipValue.trim()) {
                                        const zipRegex = /^\d+$/;
                                        if (!zipRegex.test(zipValue.trim())) {
                                            setValidationErrors(prev => ({
                                                ...prev,
                                                [`${question.id}_zip`]: 'ZIP code should only contain numbers'
                                            }));
                                        } else {
                                            setValidationErrors(prev => ({
                                                ...prev,
                                                [`${question.id}_zip`]: null
                                            }));
                                        }
                                    } else {
                                        setValidationErrors(prev => ({
                                            ...prev,
                                            [`${question.id}_zip`]: null
                                        }));
                                    }
                                }}
                                error={Boolean(validationErrors[`${question.id}_zip`])}
                                helperText={validationErrors[`${question.id}_zip`]}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '& fieldset': {
                                            borderColor: surveyTheme?.borderColor || 'divider'
                                        },
                                        '&:hover fieldset': {
                                            borderColor: surveyTheme?.accentColor || '#1976d2'
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: surveyTheme?.accentColor || '#1976d2'
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        color: surveyTheme?.textColor || 'text.primary',
                                        '&::placeholder': {
                                            color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                        }
                                    }
                                }}
                            />
                        </Box>
                        <TextField
                            fullWidth
                            placeholder="Country"
                            value={answers[`${question.id}_country`] || ''}
                            onChange={(e) => handleAnswer(`${question.id}_country`, e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                    color: surveyTheme?.textColor || 'text.primary',
                                    '& fieldset': {
                                        borderColor: surveyTheme?.borderColor || 'divider'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: surveyTheme?.accentColor || '#1976d2'
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: surveyTheme?.accentColor || '#1976d2'
                                    }
                                },
                                '& .MuiInputBase-input': {
                                    color: surveyTheme?.textColor || 'text.primary',
                                    '&::placeholder': {
                                        color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                    }
                                }
                            }}
                        />
                        {(hasError) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage('Please fill in the address fields')}
                            </FormHelperText>
                        )}
                    </Box>
                );

            case 'long-answer':
                return (
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder={question.placeholder || 'Your detailed response'}
                        value={answers[question.id] !== undefined ? answers[question.id] : (question.defaultValue || '')}
                        onChange={(e) => handleAnswer(question.id, e.target.value)}
                        error={hasError}
                        helperText={getErrorMessage()}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: surveyTheme?.textColor || 'text.primary',
                                '&::placeholder': {
                                    color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                }
                            },
                            '& .MuiFormHelperText-root': {
                                color: surveyTheme?.textColor || 'text.primary'
                            }
                        }}
                    />
                );

            case 'email':
                return (
                    <TextField
                        fullWidth
                        type="email"
                        placeholder={question.placeholder || 'email@example.com'}
                        value={answers[question.id] !== undefined ? answers[question.id] : (question.defaultValue || '')}
                        onChange={(e) => handleAnswer(question.id, e.target.value)}
                        error={hasError}
                        helperText={getErrorMessage()}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: surveyTheme?.textColor || 'text.primary',
                                '&::placeholder': {
                                    color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                }
                            },
                            '& .MuiFormHelperText-root': {
                                color: surveyTheme?.textColor || 'text.primary'
                            }
                        }}
                    />
                );

            case 'number':
                return (
                    <TextField
                        fullWidth
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder={question.placeholder || '0'}
                        value={answers[question.id] !== undefined ? answers[question.id] : (question.defaultValue || '')}
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            // Allow empty string (for clearing the field)
                            if (inputValue === '') {
                                handleAnswer(question.id, '');
                                return;
                            }
                            // Only allow numeric characters
                            const numericValue = inputValue.replace(/[^0-9]/g, '');
                            handleAnswer(question.id, numericValue);
                        }}
                        error={hasError}
                        helperText={getErrorMessage()}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: surveyTheme?.textColor || 'text.primary',
                                '&::placeholder': {
                                    color: alpha(surveyTheme?.textColor || '#000', 0.5)
                                }
                            },
                            '& .MuiFormHelperText-root': {
                                color: surveyTheme?.textColor || 'text.primary'
                            }
                        }}
                    />
                );

            case 'phone':
                return (
                    <FormControl fullWidth variant="outlined" sx={{ mt: 1 }}>
                        <OutlinedInput
                            type="tel"
                            placeholder={question.placeholder || '+1 (123) 456-7890'}
                            value={answers[question.id] || ''}
                            onChange={(e) => {
                                let formatted = e.target.value.replace(/\D/g, '');
                                if (formatted.length > 0) {
                                    if (formatted.length <= 10) {
                                        // US format
                                        formatted = formatted.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                                        formatted = (!formatted[2] ? formatted[1] : 
                                            '(' + formatted[1] + ') ' +
                                            (formatted[2] ? formatted[2] : '') +
                                            (formatted[3] ? '-' + formatted[3] : ''));
                                    } else {
                                        // International format
                                        formatted = formatted.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
                                        formatted = (!formatted[2] ? formatted[1] : 
                                            '+' + formatted[1] + ' (' + formatted[2] + ') ' +
                                            (formatted[3] ? formatted[3] : '') +
                                            (formatted[4] ? '-' + formatted[4] : ''));
                                    }
                                }
                                handleAnswer(question.id, formatted);
                            }}
                            error={hasError && question.required}
                            startAdornment={
                                <InputAdornment position="start">
                                    <PhoneIcon sx={{ color: 'text.secondary' }} />
                                </InputAdornment>
                            }
                            sx={{
                                bgcolor: 'transparent',
                                '& input': {
                                    letterSpacing: '0.5px',
                                    fontFamily: 'monospace',
                                    fontSize: '1rem',
                                    color: 'text.primary'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'divider'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'primary.main'
                                }
                            }}
                        />
                        {((hasError && question.required)) && (
                            <FormHelperText error={hasError && question.required}>
                                {(hasError && question.required) && getErrorMessage()}
                            </FormHelperText>
                        )}
                    </FormControl>
                );

            case 'date':
                return (
                    <TextField
                        fullWidth
                        type="date"
                        value={answers[question.id] !== undefined ? answers[question.id] : (question.defaultValue || '')}
                        onChange={(e) => handleAnswer(question.id, e.target.value)}
                        error={hasError}
                        helperText={getErrorMessage()}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`,
                                color: surveyTheme?.textColor || 'text.primary',
                                '& fieldset': {
                                    borderColor: surveyTheme?.borderColor || 'divider'
                                },
                                '&:hover fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: surveyTheme?.accentColor || '#1976d2'
                                },
                                '&.Mui-focused': {
                                    bgcolor: `${surveyTheme?.inputBg || 'background.paper'} !important`
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: surveyTheme?.textColor || 'text.primary'
                            },
                            '& .MuiFormHelperText-root': {
                                color: surveyTheme?.textColor || 'text.primary'
                            }
                        }}
                    />
                );

            case 'file-upload':
                const getFileType = (filename) => {
                    if (!filename) return 'unknown';
                    if (/\.(jpg|jpeg|png|gif)$/i.test(filename)) return 'image';
                    if (/\.pdf$/i.test(filename)) return 'pdf';
                    if (/\.(doc|docx)$/i.test(filename)) return 'doc';
                    return 'unknown';
                };

                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                            type="file"
                            id={`file-${question.id}`}
                            style={{ display: 'none' }}
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    // Check file size (5MB limit)
                                    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                                    if (file.size > maxSize) {
                                        setValidationErrors(prev => ({
                                            ...prev,
                                            [question.id]: 'File size must be less than 5MB'
                                        }));
                                        e.target.value = '';
                                        return;
                                    }

                                    // Store file temporarily
                                    setTempFiles(prev => ({
                                        ...prev,
                                        [question.id]: file
                                    }));

                                    // Store file name in answers for display
                                    setAnswers(prev => ({
                                        ...prev,
                                        [question.id]: file.name
                                    }));

                                    e.target.value = '';
                                }
                            }}
                            accept={question.allowedFileTypes?.map(type => `.${type}`).join(',')}
                        />
                        {!answers[question.id] ? (
                            <Box sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                gap: 1,
                                alignItems: { xs: 'stretch', sm: 'center' },
                                // justifyContent: 'start',
                            }}>
                                <label htmlFor={`file-${question.id}`} style={{ width: '100%' }}>
                                    <Button
                                        variant="outlined"
                                        component="span"
                                        disabled={Boolean(answers[question.id])}
                                        fullWidth
                                        sx={{ mb: { xs: 1, sm: 0 } }}
                                    >
                                        Choose File
                                    </Button>
                                </label>
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    // sx={{ textAlign: { xs: 'center', sm: 'left' } }}
                                >
                                    Maximum file size: 5MB
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                gap: 1
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    p: 1,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    // bgcolor: 'background.paper',
                                    width: '100%'
                                }}>
                                    <Box sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 1,
                                        overflow: 'hidden',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bgcolor: 'grey.100',
                                        flexShrink: 0,
                                        mr: 1
                                    }}>
                                        {getFileType(answers[question.id]) === 'image' ? (
                                            <Box
                                                component="img"
                                                src={URL.createObjectURL(tempFiles[question.id])}
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        ) : getFileType(answers[question.id]) === 'pdf' ? (
                                            <Box sx={{
                                                bgcolor: '#f44336',
                                                color: 'white',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                PDF
                                            </Box>
                                        ) : getFileType(answers[question.id]) === 'doc' ? (
                                            <Box sx={{
                                                bgcolor: '#2196f3',
                                                color: 'white',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                DOC
                                            </Box>
                                        ) : (
                                            <Box sx={{
                                                bgcolor: 'grey.300',
                                                color: 'text.secondary',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                FILE
                                            </Box>
                                        )}
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            flex: 1,
                                            minWidth: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',

                                        }}
                                    >
                                        {answers[question.id]}
                                    </Typography>
                                    <Button
                                        size="small"
                                        color="error"
                                        onClick={() => {
                                            setAnswers(prev => ({ ...prev, [question.id]: null }));
                                            setTempFiles(prev => {
                                                const newFiles = { ...prev };
                                                delete newFiles[question.id];
                                                return newFiles;
                                            });
                                        }}
                                        sx={{ ml: 1 }}
                                    >
                                        ×
                                    </Button>
                                </Box>
                            </Box>
                        )}

                        {(hasError) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage('Please select a file')}
                            </FormHelperText>
                        )}
                    </Box>
                );

            // case 'rating':
            //     return (
            //         <Box>
            //             <Rating
            //                 value={Number(answers[question.id]) || 0}
            //                 onChange={(_, value) => handleAnswer(question.id, value)}
            //                 max={question.config?.max || 5}
            //             />
            //             {(hasError) && (
            //                 <FormHelperText error={hasError} sx={{ mt: 1 }}>
            //                     {getErrorMessage('Please provide a rating')}
            //                 </FormHelperText>
            //             )}
            //         </Box>
            //     );
             case 'rating':
                return (
                    <Box>
                        <Rating
                            value={Number(answers[question.id]) || 0}
                            onChange={(_, value) => handleAnswer(question.id, value)}
                            max={question.config?.max || 5}
                            // ensure empty (unfilled) stars use the question text color so they are visible in dark themes
                            emptyIcon={<StarBorderIcon sx={{ fontSize: '1.6rem', color: surveyTheme?.textColor || 'rgba(0,0,0,0.38)' }} />}
                            icon={<StarIcon sx={{ fontSize: '1.6rem', color: surveyTheme?.textColor || '#FFD700' }} />}
                            sx={{
                                '& .MuiRating-iconEmpty': {
                                    color: surveyTheme?.textColor || 'rgba(0,0,0,0.38)'
                                },
                                '& .MuiSvgIcon-root': {
                                    // fallback color for filled icons (keeps accent for filled)
                                    color: surveyTheme?.textColor || '#FFD700'
                                }
                            }}
                        />
                        {(hasError) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage('Please provide a rating')}
                            </FormHelperText>
                        )}
                    </Box>
                );

           case 'multiple-choice':
            case 'multiple_choice':
                console.log('Rendering multiple-choice question:', question.id, question.options);
                const multipleChoiceOptions = getRandomizedOptions(question);

                return (
                    <FormControl
                        required={question.required}
                        error={Boolean(validationErrors[question.id])}
                        sx={{ width: '100%' }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {multipleChoiceOptions.map((option, idx) => (
                                <Box
                                    key={idx}
                                    sx={{
                                        border: '2px solid',
                                        borderColor: answers[question.id] === option
                                            ? surveyTheme.accentColor
                                            : 'divider',
                                        borderRadius: 2,
                                        bgcolor: answers[question.id] === option
               ? alpha(surveyTheme?.accentColor || '#1976d2', 0.08)
               : surveyTheme?.bg || 'background.paper',
                                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            borderColor: answers[question.id] === option
                                                ? surveyTheme.accentColor
                                                : surveyTheme.accentColor || 'divider',
                                            bgcolor: answers[question.id] === option
                                                ? alpha(surveyTheme.accentColor, 0.12)
                                                : surveyTheme?.accentColor ? `${surveyTheme.accentColor}05` : alpha(surveyTheme.accentColor, 0.04),
                                            transform: 'translateY(-1px)',
                                            boxShadow: `0 2px 8px ${alpha('#000', 0.08)}`
                                        }
                                    }}
                                    onClick={() => handleAnswer(question.id, option)}
                                >
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingInline: '2%',
                                        paddingBlock: '2%',
                                        gap: 3
                                    }}>
                                        {/* Letter Label */}
                                        <Box sx={{
                                            minWidth: '28px',
                                            height: '28px',
                                            borderRadius: '6px',
                                            border: '2px solid',
                                            borderColor: answers[question.id] === option
                                                ? surveyTheme.accentColor
                                                : surveyTheme?.textColor || '#000',
                                            bgcolor: answers[question.id] === option
                                                ? surveyTheme.accentColor
                                                : 'transparent',
                                            color: answers[question.id] === option
                                                ? 'white'
                                                : surveyTheme?.textColor || '#000',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '0.75rem',
                                            fontWeight: 700,
                                            transition: 'all 0.2s ease',
                                            flexShrink: 0
                                        }}>
                                            {String.fromCharCode(65 + idx)}
                                        </Box>

                                        {/* Option Text */}
                                        <Typography
                                            sx={{
                                                color: surveyTheme?.textColor || '#000',
                                                fontSize: '1.125rem',
                                                fontWeight: answers[question.id] === option ? 600 : 400,
                                                flex: 1,
                                                lineHeight: 1.4
                                            }}
                                        >
                                            {option}
                                        </Typography>

                                        {/* Hidden Radio for form handling */}
                                        <Radio
                                            checked={answers[question.id] === option}
                                            value={option}
                                            sx={{ display: 'none' }}
                                        />
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        {(hasError) && (
                            <FormHelperText error={hasError}>
                                {getErrorMessage()}
                            </FormHelperText>
                        )}
                    </FormControl>
                ); case 'checkboxes':
                // Use randomized options for checkboxes
                const checkboxOptions = getRandomizedOptions(question);
                const checkboxValues = answers[question.id] ? JSON.parse(answers[question.id]) : [];

                return (
                    <FormControl
                        required={question.required}
                        error={Boolean(validationErrors[question.id])}
                        sx={{ width: '100%' }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {checkboxOptions.map((option, idx) => (
                                <Box
                                    key={idx}
                                    sx={{
                                        border: '2px solid',
                                        borderColor: checkboxValues.includes(option)
                                            ? surveyTheme.accentColor
                                            : 'divider',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        transition: 'all 0.2s ease',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            borderColor: surveyTheme.accentColor,
                                            bgcolor: alpha(surveyTheme.accentColor, 0.02),
                                            transform: 'translateY(-1px)',
                                            boxShadow: `0 4px 12px ${alpha(surveyTheme.accentColor, 0.15)}`
                                        },
                                        '&:active': {
                                            transform: 'translateY(0)',
                                            boxShadow: `0 2px 8px ${alpha(surveyTheme.accentColor, 0.2)}`
                                        }
                                    }}

                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={checkboxValues.includes(option)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    const newValues = e.target.checked
                                                        ? [...checkboxValues, option]
                                                        : checkboxValues.filter(v => v !== option);
                                                    handleAnswer(question.id, JSON.stringify(newValues));
                                                }}
                                                onFocus={() => handleQuestionFocus(question.id)}
                                                onBlur={() => handleQuestionBlur(question.id)}
                                                sx={{
                                                    mx: 2,
                                                    my: 1.5,
                                                    color: surveyTheme?.borderColor || 'divider',
                                                    '&.Mui-checked': {
                                                        color: surveyTheme?.accentColor || '#1976d2'
                                                    }
                                                }}
                                            />
                                        }
                                        label={
                                            <Typography
                                                sx={{
                                                    color: surveyTheme?.textColor || 'text.primary',
                                                    fontSize: '1rem',
                                                    fontWeight: checkboxValues.includes(option) ? 600 : 400,
                                                    py: 1.5,
                                                    pr: 2,
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {option}
                                            </Typography>
                                        }
                                        sx={{
                                            margin: 0,
                                            width: '100%',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            '& .MuiFormControlLabel-label': {
                                                flex: 1
                                            }
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const newValues = checkboxValues.includes(option)
                                                ? checkboxValues.filter(v => v !== option)
                                                : [...checkboxValues, option];
                                            handleAnswer(question.id, JSON.stringify(newValues));
                                        }}
                                    />
                                </Box>
                            ))}
                        </Box>

                        {(hasError) && (
                            <FormHelperText error={hasError}>
                                {getErrorMessage()}
                            </FormHelperText>
                        )}
                    </FormControl>
                );

            case 'image-choice':
                // Parse existing answers correctly
                // Parse the selected values properly for multiple selection
                let selectedValues = [];
                if (answers[question.id]) {
                    if (typeof answers[question.id] === 'string') {
                        try {
                            selectedValues = JSON.parse(answers[question.id]);
                            if (!Array.isArray(selectedValues)) {
                                selectedValues = [answers[question.id]];
                            }
                        } catch (e) {
                            selectedValues = [answers[question.id]];
                        }
                    } else if (Array.isArray(answers[question.id])) {
                        selectedValues = answers[question.id];
                    } else {
                        selectedValues = [answers[question.id]];
                    }
                }

                return (
                    <Box sx={{ width: '100%' }}>
                        <FormControl component="fieldset" fullWidth>
                            {question.allowMultipleSelection ? (
                                <FormGroup>                        <Grid container spacing={3}>
                                    {question.options?.map((option, idx) => (
                                        <Grid item xs={12} sm={6} md={4} key={idx}>
                                            <Box
                                                sx={{
                                                    border: '3px solid',
                                                    borderColor: selectedValues.includes(JSON.stringify(option))
                                                        ? surveyTheme?.accentColor || '#1976d2'
                                                        : 'divider',
                                                    borderRadius: 3,
                                                    overflow: 'hidden',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer',
                                                    bgcolor: selectedValues.includes(JSON.stringify(option))
                                                        ? alpha(surveyTheme?.accentColor || '#1976d2', 0.05)
                                                        : 'transparent',
                                                    '&:hover': {
                                                        borderColor: surveyTheme?.accentColor || '#1976d2',
                                                        bgcolor: alpha(surveyTheme?.accentColor || '#1976d2', 0.08),
                                                        transform: 'translateY(-4px)',
                                                        boxShadow: `0 8px 25px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.25)}`
                                                    },
                                                    '&:active': {
                                                        transform: 'translateY(-2px)',
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    // Don't handle container clicks for checkbox mode - let the FormControlLabel handle it
                                                    return;
                                                }}
                                            >
                                                {/* Image Container */}
                                                <Box sx={{
                                                    position: 'relative',
                                                    bgcolor: 'transparent',
                                                    aspectRatio: '16/10'
                                                }}>
                                                    {option.imageUrl ? (
                                                        <img
                                                            src={option.imageUrl}
                                                            alt={option.label || `Option ${idx + 1}`}
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                    ) : (
                                                        <Box sx={{
                                                            width: '100%',
                                                            height: '100%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: 'text.secondary'
                                                        }}>
                                                            <ImageIcon sx={{ fontSize: '3rem' }} />
                                                        </Box>
                                                    )}

                                                    {/* Selection Overlay */}
                                                    {selectedValues.includes(JSON.stringify(option)) && (
                                                        <Box sx={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            bgcolor: alpha(surveyTheme?.accentColor || '#1976d2', 0.2),
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <Box sx={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: '50%',
                                                                bgcolor: surveyTheme?.accentColor || '#1976d2',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: 'white'
                                                            }}>
                                                                ✓
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Box>

                                                {/* Content */}
                                                <Box sx={{ p: 2.5 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={selectedValues.includes(JSON.stringify(option))}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    const newValues = e.target.checked
                                                                        ? [...selectedValues, JSON.stringify(option)]
                                                                        : selectedValues.filter(val => val !== JSON.stringify(option));
                                                                    handleAnswer(question.id, JSON.stringify(newValues));
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                                sx={{
                                                                    color: surveyTheme?.borderColor || 'divider',
                                                                    '&.Mui-checked': {
                                                                        color: surveyTheme?.accentColor || '#1976d2'
                                                                    }
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography sx={{
                                                                fontWeight: selectedValues.includes(JSON.stringify(option)) ? 600 : 500,
                                                                fontSize: '1rem',
                                                                color: surveyTheme?.textColor || 'text.primary'
                                                            }}>
                                                                {option.label || `Option ${idx + 1}`}
                                                            </Typography>
                                                        }
                                                        sx={{ margin: 0, width: '100%' }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const isCurrentlySelected = selectedValues.includes(JSON.stringify(option));
                                                            const newValues = isCurrentlySelected
                                                                ? selectedValues.filter(val => val !== JSON.stringify(option))
                                                                : [...selectedValues, JSON.stringify(option)];
                                                            handleAnswer(question.id, JSON.stringify(newValues));
                                                        }}
                                                    />
                                                    {option.showDescription && option.description && (
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{
                                                                mt: 1,
                                                                lineHeight: 1.5,
                                                                pl: 4.5
                                                            }}
                                                        >
                                                            {option.description}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                                </FormGroup>
                            ) : (
                                <RadioGroup
                                    value={answers[question.id] || ''}
                                    onChange={(e) => handleAnswer(question.id, e.target.value)}
                                >                        <Grid container spacing={3}>
                                        {question.options?.map((option, idx) => (
                                            <Grid item xs={12} sm={6} md={4} key={idx}>
                                                <Box
                                                    sx={{
                                                        border: '3px solid',
                                                        borderColor: answers[question.id] === JSON.stringify(option)
                                                            ? surveyTheme?.accentColor || '#1976d2'
                                                            : 'divider',
                                                        borderRadius: 3,
                                                        overflow: 'hidden',
                                                        transition: 'all 0.3s ease',
                                                        cursor: 'pointer',
                                                        bgcolor: answers[question.id] === JSON.stringify(option)
                                                            ? alpha(surveyTheme?.accentColor || '#1976d2', 0.05)
                                                            : 'transparent',
                                                        '&:hover': {
                                                            borderColor: surveyTheme?.accentColor || '#1976d2',
                                                            bgcolor: alpha(surveyTheme?.accentColor || '#1976d2', 0.08),
                                                            transform: 'translateY(-4px)',
                                                            boxShadow: `0 8px 25px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.25)}`
                                                        },
                                                        '&:active': {
                                                            transform: 'translateY(-2px)',
                                                        }
                                                    }}
                                                    onClick={(e) => {
                                                        // Only handle click if it's not on the radio or label
                                                        if (e.target.type === 'radio' ||
                                                            e.target.closest('.MuiFormControlLabel-root')) {
                                                            return; // Let the radio handle it
                                                        }

                                                        handleAnswer(question.id, JSON.stringify(option));
                                                    }}
                                                >
                                                    {/* Image Container */}
                                                    <Box sx={{
                                                        position: 'relative',
                                                        bgcolor: 'transparent',
                                                        aspectRatio: '16/10'
                                                    }}>
                                                        {option.imageUrl ? (
                                                            <img
                                                                src={option.imageUrl}
                                                                alt={option.label || `Option ${idx + 1}`}
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover'
                                                                }}
                                                            />
                                                        ) : (
                                                            <Box sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: 'text.secondary'
                                                            }}>
                                                                <ImageIcon sx={{ fontSize: '3rem' }} />
                                                            </Box>
                                                        )}

                                                        {/* Selection Overlay */}
                                                        {answers[question.id] === JSON.stringify(option) && (
                                                            <Box sx={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                bgcolor: alpha(surveyTheme.accentColor, 0.2),
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                                <Box sx={{
                                                                    width: 40,
                                                                    height: 40,
                                                                    borderRadius: '50%',
                                                                    bgcolor: surveyTheme.accentColor,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: 'white'
                                                                }}>
                                                                    ✓
                                                                </Box>
                                                            </Box>
                                                        )}
                                                    </Box>

                                                    {/* Content */}
                                                    <Box sx={{ p: 2.5 }}>
                                                        <FormControlLabel
                                                            value={JSON.stringify(option)}
                                                            control={
                                                                <Radio
                                                                    sx={{
                                                                        color: surveyTheme?.borderColor || 'divider',
                                                                        '&.Mui-checked': {
                                                                            color: surveyTheme?.accentColor || '#1976d2'
                                                                        }
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <Typography sx={{
                                                                    fontWeight: answers[question.id] === JSON.stringify(option) ? 600 : 500,
                                                                    fontSize: '1rem',
                                                                    color: surveyTheme?.textColor || 'text.primary'
                                                                }}>
                                                                    {option.label || `Option ${idx + 1}`}
                                                                </Typography>
                                                            }
                                                            sx={{ margin: 0, width: '100%' }}
                                                        />
                                                        {option.showDescription && option.description && (
                                                            <Typography
                                                                variant="body2"
                                                                color={surveyTheme?.textColor || 'text.secondary'}
                                                                sx={{
                                                                    mt: 1,
                                                                    lineHeight: 1.5,
                                                                    pl: 4.5,
                                                                    opacity: 0.7
                                                                }}
                                                            >
                                                                {option.description}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </RadioGroup>
                            )}
                        </FormControl>
                        {(hasError) && (
                            <FormHelperText error={hasError} sx={{ mt: 1 }}>
                                {getErrorMessage()}
                            </FormHelperText>
                        )}
                    </Box>
                );

            case 'range-scale':
                return (
                    <Box sx={{ width: '100%', px: { xs: 1, sm: 2 }, mt: 3 }}>
                        <Slider
                            value={parseInt(answers[question.id] || question.config?.defaultValue || 50)}
                            onChange={(_, value) => handleAnswer(question.id, value.toString())}
                            min={question.config?.min || 0}
                            max={question.config?.max || 100}
                            step={question.config?.step || 1}
                            marks={question.config?.showTicks && [
                                {
                                    value: question.config?.min || 0,
                                    label: question.config?.labels?.start || 'Low'
                                },
                                {
                                    value: (question.config?.max + question.config?.min) / 2 || 50,
                                    label: question.config?.labels?.middle || 'Medium'
                                },
                                {
                                    value: question.config?.max || 100,
                                    label: question.config?.labels?.end || 'High'
                                }
                            ]}
                            sx={{
                                '& .MuiSlider-markLabel': {
                                    color: 'text.secondary',
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                }
                            }}
                        />
                        {!question.config?.showTicks && (
                            <Box
                                sx={{
                                    mt: 2,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    color: 'text.secondary',
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                                }}
                            >
                                <Typography variant="caption">
                                    {question.config?.labels?.start || 'Low'}
                                </Typography>
                                <Typography variant="caption">
                                    {question.config?.labels?.end || 'High'}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                );

            default:
                return (
                    <Typography color="error">
                        Unsupported question type: {question.type}
                    </Typography>
                );
        }
    }; return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            {/* Global Confetti Animation */}
            {submitted && showConfetti && (
                <Confetti
                    width={windowDimensions.width}
                    height={windowDimensions.height}
                    recycle={false}
                    numberOfPieces={500}
                    gravity={0.25}
                    run={true}
                    initialVelocityY={25}
                    colors={['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff', '#5f27cd']}
                    wind={0.02}
                    style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999 }}
                />
            )}

            <Box sx={{
                minHeight: '100vh',
                bgcolor: surveyTheme?.bg || 'background.default',
                color: surveyTheme?.textColor || 'text.primary'
            }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Box sx={{ p: 3 }}>
                        <Alert severity="error">{error}</Alert>
                    </Box>) : hasWelcomePage && currentQuestionIndex === -2 ? (
                        <Container maxWidth="md" sx={{
                            py: 4,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '100vh',
                            width: '100%',
                            bgcolor: surveyTheme?.bg || '#ffffff'
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    gap: 4
                                }}
                            >
                                <Box
                                    component="img"
                                    src={survey?.form_settings?.welcome_image}
                                    alt="Welcome"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                    sx={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        maxHeight: '400px',
                                        objectFit: 'contain',
                                        borderRadius: 2
                                    }}
                                />
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            mb: 2,
                                            color: surveyTheme?.textColor || '#000000',
                                            fontWeight: 600
                                        }}
                                    >
                                        {survey?.form_settings?.welcome_title || 'Welcome to our survey!'}
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            whiteSpace: 'pre-line',
                                            mb: 3,
                                            color: surveyTheme?.textColor || '#666666',
                                            fontWeight: 400,
                                            opacity: 0.8
                                        }}
                                    >
                                        {survey?.form_settings?.welcome_description || 'Please take a moment to share your thoughts.'}
                                    </Typography>
                                </Box>                            <Button
                                    variant="contained"
                                    size="large"
                                    onClick={() => setCurrentQuestionIndex(-1)}
                                    sx={{
                                        minWidth: 200,
                                        py: 1.5,
                                        bgcolor: surveyTheme?.accentColor || '#1976d2',
                                        color: '#ffffff',
                                        fontSize: '1rem',
                                        fontWeight: 600,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        '&:hover': {
                                            bgcolor: surveyTheme?.accentColor ? `${surveyTheme.accentColor}dd` : '#1565c0',
                                            transform: 'translateY(-2px)',
                                            boxShadow: `0 4px 12px ${surveyTheme?.accentColor ? `${surveyTheme.accentColor}40` : '#1976d240'}`
                                        }
                                    }}
                                >
                                    Start Survey
                                </Button>
                            </Box>
                        </Container>
                    ) : (

                    <Container maxWidth="xl" sx={{ py: !surveyLayout === 'classic' && 4, bgcolor: surveyTheme?.bg, minHeight: '100vh', }}>
                        {submitted ? (
                            <ThankYouScreen
                                formSettings={survey?.form_settings}
                                submissionSucceeded={submitted}
                            />
                        ) : (<Paper elevation={0}
                            sx={{
                                p: 4, minHeight: '100vh', display: 'flex', flexDirection: 'column',
                                backgroundColor: surveyTheme?.bg,
                                color: surveyTheme.textColor,
                                '& .MuiTypography-root': {
                                    color: surveyTheme.textColor
                                },
                                '& .MuiFormLabel-root': {
                                    color: surveyTheme.textColor
                                },
                                '& .MuiInputBase-root': {
                                    // backgroundColor: surveyTheme.inputBg,
                                    color: surveyTheme.textColor,
                                    '& fieldset': {
                                        borderColor: surveyTheme.borderColor
                                    },
                                    '&:hover fieldset': {
                                        borderColor: surveyTheme.accentColor
                                    },
                                    '& input': {
                                        color: surveyTheme.textColor,
                                    },
                                    '& input::placeholder': {
                                        color: `${surveyTheme.textColor}80`, // 50% opacity
                                    }
                                },
                                '& input': {
                                    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
                                        transition: 'background-color 5000s ease-in-out 0s',
                                        WebkitTextFillColor: `${surveyTheme.textColor} !important`,
                                        WebkitBoxShadow: 'none',
                                        background: 'none !important',
                                        backgroundColor: 'transparent !important'
                                    }
                                },

                                '& .MuiButton-contained': {
                                    backgroundColor: surveyTheme.accentColor,

                                    '&:hover': {
                                        backgroundColor: surveyTheme.accentColor
                                    }
                                },
                                '& .MuiButton-outlined': {
                                    borderColor: surveyTheme.accentColor,
                                    color: surveyTheme.accentColor
                                },
                                '& .MuiRadio-root, & .MuiCheckbox-root': {
                                    color: surveyTheme.textColor,
                                    '&.Mui-checked': {
                                        color: surveyTheme.accentColor
                                    },

                                },
                                '& .MuiSlider-root': {
                                    color: surveyTheme.accentColor
                                },
                                '&.Mui-focused': {
                                    backgroundColor: surveyTheme.inputBg,
                                    '& fieldset': {
                                        borderColor: surveyTheme.accentColor,
                                        borderWidth: '2px'
                                    }
                                }
                                ,
                                '& .MuiSelect-select': {
                                    '&:focus': {
                                        // backgroundColor: 'transparent'
                                    }
                                },
                                '& .MuiFormLabel-root': {
                                    color: surveyTheme.textColor,
                                    '&.Mui-focused': {
                                        // color: surveyTheme.accentColor
                                    }
                                },
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: surveyTheme.accentColor,
                                    borderWidth: '2px'
                                },
                                '& .MuiAutocomplete-listbox': {
                                    backgroundColor: surveyTheme.inputBg,
                                    color: surveyTheme.textColor,
                                    '& .MuiAutocomplete-option': {
                                        '&:hover': {
                                            backgroundColor: `${surveyTheme.accentColor}20`
                                        },
                                        '&[aria-selected="true"]': {
                                            backgroundColor: `${surveyTheme.accentColor}40`
                                        }

                                    }
                                },
                                '& .MuiAutocomplete-popper': {
                                    backgroundColor: surveyTheme.inputBg,
                                    '& .MuiPaper-root': {
                                        backgroundColor: surveyTheme.inputBg,
                                        color: surveyTheme.textColor,
                                        border: `1px solid ${surveyTheme.borderColor}`
                                    }
                                },


                            }}>
                          

                            <form onSubmit={handleSubmit}
                                noValidate
                                style={{ flex: 1, display: 'flex', flexDirection: 'column',justifyContent: 'flex-start', maxHeight:'100%'}}
                            >
                                {logicEvaluation.errors.length > 0 && (
                                    <Alert severity="error" sx={{ mb: 2 }}>
                                        Survey logic needs attention: {logicEvaluation.errors.map(item => item.error).filter(Boolean).join('; ')}
                                    </Alert>
                                )}
                                {logicEvaluation.messagesToShow.map((item, index) => (
                                    <Alert key={`${item.message}-${index}`} severity={['error', 'warning', 'success', 'info'].includes(item.type) ? item.type : 'info'} sx={{ mb: 2 }}>
                                        {item.message}
                                    </Alert>
                                ))}
                                {questions && questions.length > 0 ? (
                                    surveyLayout === 'classic' ? (
                                        <>
                                            {renderEmailField()}
                                            {visibleQuestions.map((question) => (
                                                <Box key={question.id} sx={{ mb: 4 }}>
                                                    <Typography variant="h6" gutterBottom>
                                                        {decodeHTMLEntities(question.title)}
                                                        {question.required && <span style={{ color: 'red' }}> *</span>}
                                                    </Typography>
                                                    {question.caption && (
                                                        <Typography variant="body2" sx={{ mb: 2, color: surveyTheme.textColor, opacity: 0.7 }}>
                                                            {question.caption}
                                                        </Typography>
                                                    )}
                                                    {renderQuestion(question)}
                                                </Box>
                                            ))}
                                            <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
                                                <Button type="submit" variant="contained" color="primary">
                                                    Submit
                                                </Button>
                                            </Box>
                                        </>) :
                                        (<>                                        {/* Typeform/Fillout Style Header */}
                                            <Box sx={{
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 1000,
                                                bgcolor: alpha(surveyTheme?.bg || '#ffffff', 0.98),
                                                backdropFilter: 'blur(12px)',
                                                mb: 4
                                            }}>
                                                {/* Survey Title in Top Right */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    px: { xs: 3, sm: 4, md: 6 },
                                                    py: 3
                                                }}>
                                                    <Typography
                                                        variant="h6"
                                                        component="h1"
                                                        sx={{
                                                            fontWeight: 500,
                                                            color: surveyTheme.textColor || 'text.primary',
                                                            fontSize: { xs: '1rem', sm: '1.125rem' },
                                                            opacity: 0.8
                                                        }}
                                                    >
                                                        {survey && survey.name && decodeHTMLEntities(survey.name)}
                                                    </Typography>
                                                </Box>

                                                {/* Full Width Progress Bar */}
                                                <Box sx={{
                                                    width: '100%',
                                                    height: 3,
                                                    bgcolor: alpha(surveyTheme.accentColor || '#3b82f6', 0.1),
                                                    position: 'relative'
                                                }}>
                                                    <Box sx={{
                                                        height: '100%',
                                                        bgcolor: surveyTheme.accentColor || '#3b82f6',
                                                        width: `${Math.max(2, ((visibleQuestions.findIndex(question => question.id === questions[currentQuestionIndex]?.id) + 1) / Math.max(visibleQuestions.length, 1)) * 100)}%`,
                                                        transition: 'width 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                                        borderRadius: '0 2px 2px 0'
                                                    }} />
                                                </Box>
                                            </Box>   
                                                                                 {/* Main Content Area */}
                                            <Card elevation={6} sx={{
                                                minHeight: '60vh',
                                                maxHeight: '60vh',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-start',
                                                maxWidth: '900px',
                                                mx: 'auto',
                                                marginBlock:"4%",
                                                width: '100%',
                                                borderRadius: 2,
                                                bgcolor: alpha(surveyTheme?.bg || '#ffffff', 0.98),
                                                // bgcolor: surveyTheme.bgcolor ,
                                                // boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)'
                                            }}>
                                                <CardContent sx={{
                                                  px: { xs: 4, sm: 8, md: 12 },
                                                  py: { xs: 4, sm: 6 },
                                                  flex: 1,
                                                  display: 'flex',
                                                  flexDirection: 'column'
                                                }}>
                                                {currentQuestionIndex === -1 ? (
                                                /* Email Collection Screen */
                                                <Box sx={{
                                                    maxWidth: '700px',
                                                    pt: { xs: 2, sm: 4 }
                                                }}>
                                                    {/* Only show welcome text if there's no dedicated welcome page */}
                                                    {!hasWelcomePage && (
                                                        <>
                                                            <Typography
                                                                variant="h3"
                                                                sx={{
                                                                    mb: 3,
                                                                    fontWeight: 700,
                                                                    color: surveyTheme.textColor,
                                                                    fontSize: { xs: '1.75rem', sm: '2.25rem' },
                                                                    lineHeight: 1.2
                                                                }}
                                                            >
                                                                Welcome to {survey?.name}
                                                            </Typography>
                                                            {survey?.description && (
                                                                <Typography
                                                                    variant="h6"
                                                                    sx={{
                                                                        mb: 6,
                                                                        color: surveyTheme.textColor,
                                                                        opacity: 0.7,
                                                                        lineHeight: 1.5,
                                                                        fontSize: '1.125rem',
                                                                        fontWeight: 400
                                                                    }}
                                                                >
                                                                    {survey.description}
                                                                </Typography>
                                                            )}
                                                        </>
                                                    )}
                                                    {renderEmailField()}
                                                </Box>
                                            ) : questionVisibility[String(questions[currentQuestionIndex]?.id)] === false ? null : (
                                                /* Question Display - Typeform Style */
                                                <Box sx={{
                                                    width: '100%',
                                                    pt: { xs: 2, sm: 4 }
                                                }}>                                                    {/* Question Number and Progress */}
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        mb: 3,
                                                        gap: 1
                                                    }}>
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                color: surveyTheme?.textColor || 'text.primary',
                                                                opacity: 0.6,
                                                                fontSize: '0.875rem',
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            {visibleQuestions.findIndex(question => question.id === questions[currentQuestionIndex]?.id) + 1} of {visibleQuestions.length}
                                                        </Typography>
                                                        <Box component="span" sx={{
                                                            color: surveyTheme?.accentColor || '#1976d2',
                                                            fontSize: '1rem',
                                                            fontWeight: 600
                                                        }}>
                                                            →
                                                        </Box>
                                                    </Box>
                                                    {/* Question Title */}
                                                    <Typography
                                                        variant="h3"
                                                        sx={{
                                                            color: surveyTheme?.textColor || 'text.primary',
                                                            fontWeight: 700,
                                                            lineHeight: 1.2,
                                                            fontSize: { xs: '1.75rem', sm: '2.25rem' },
                                                            mb: 2
                                                        }}
                                                    >
                                                        {decodeHTMLEntities(questions[currentQuestionIndex].title)}
                                                        {questions[currentQuestionIndex].required && (
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    color: 'error.main',
                                                                    ml: 1
                                                                }}
                                                            >
                                                                *
                                                            </Typography>
                                                        )}
                                                    </Typography>
                                                    {/* Question Caption/Description */}
                                                    {questions[currentQuestionIndex].caption && (
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                color: surveyTheme?.textColor || 'text.primary',
                                                                opacity: 0.7,
                                                                fontSize: '1.125rem',
                                                                lineHeight: 1.5,
                                                                fontWeight: 400,
                                                                mb: 4,
                                                                maxWidth: '700px'
                                                            }}
                                                        >
                                                            {questions[currentQuestionIndex].caption}
                                                        </Typography>
                                                    )}                                                    {/* Question Content */}
                                                    <Box sx={{
                                                        mt: questions[currentQuestionIndex].caption ? 0 : 4,
                                                        mb: 6,
                                                        maxHeight: '50vh',
                                                        overflowY: 'auto',
                                                        pr: 1,
                                                        '& .MuiFormControl-root': {
                                                            width: '100%'
                                                        },
                                                        '&::-webkit-scrollbar': {
                                                            width: '8px',
                                                        },
                                                        '&::-webkit-scrollbar-track': {
                                                            background: alpha(surveyTheme?.borderColor || '#e0e0e0', 0.1),
                                                            borderRadius: '4px',
                                                        },
                                                        '&::-webkit-scrollbar-thumb': {
                                                            background: alpha(surveyTheme?.accentColor || '#1976d2', 0.3),
                                                            borderRadius: '4px',
                                                            '&:hover': {
                                                                background: alpha(surveyTheme?.accentColor || '#1976d2', 0.5),
                                                            },
                                                        },
                                                    }}>
                                                        {renderQuestion(questions[currentQuestionIndex])}
                                                    </Box>


                                                </Box>
                                              
                                            )}
                                                </CardContent>
                                            </Card>

                                            {/* Modern Navigation Bar */}
                                            <Box sx={{
                                                position: 'fixed',
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                bgcolor: alpha(surveyTheme?.bg || '#ffffff', 0.95),
                                                backdropFilter: 'blur(10px)',
                                                borderTop: '1px solid',
                                                borderColor: 'divider',
                                                py: 2,
                                                zIndex: 1000
                                            }}>
                                                <Container maxWidth="lg">
                                                    <Box sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        gap: 2
                                                    }}>
                                                        {/* Previous Button */}
                                                        <Button
                                                            onClick={handlePrevQuestion}
                                                            disabled={currentQuestionIndex === -1}
                                                            startIcon={<PrevIcon />}
                                                            sx={{
                                                                visibility: currentQuestionIndex === -1 ? 'hidden' : 'visible',
                                                                px: { xs: 2, sm: 4 },
                                                                py: 1.5,
                                                                bgcolor: 'transparent',
                                                                color: surveyTheme?.accentColor || '#1976d2',
                                                                border: '2px solid',
                                                                borderColor: alpha(surveyTheme?.accentColor || '#1976d2', 0.3),
                                                                borderRadius: 3,
                                                                fontSize: '1rem',
                                                                fontWeight: 600,
                                                                minWidth: { xs: 'auto', sm: '140px' },
                                                                transition: 'all 0.2s ease',
                                                                '& .MuiButton-startIcon': {
                                                                    color: surveyTheme?.accentColor || '#1976d2'
                                                                },
                                                                '&:hover': {
                                                                    bgcolor: alpha(surveyTheme?.accentColor || '#1976d2', 0.1),
                                                                    borderColor: surveyTheme?.accentColor || '#1976d2',
                                                                    transform: 'translateY(-2px)',
                                                                    boxShadow: `0 4px 12px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.3)}`
                                                                },
                                                                '&:disabled': {
                                                                    opacity: 0.5,
                                                                    transform: 'none',
                                                                    boxShadow: 'none'
                                                                }
                                                            }}
                                                        >
                                                            {isMobile ? '' : 'Previous'}
                                                        </Button>

                                                        {/* Mobile Progress Indicator */}
                                                        {isMobile && currentQuestionIndex >= 0 && (
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                flex: 1,
                                                                justifyContent: 'center'
                                                            }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: surveyTheme?.textColor || 'text.secondary',
                                                                        fontSize: '0.875rem'
                                                                    }}
                                                                >
                                                                    {visibleQuestions.findIndex(question => question.id === questions[currentQuestionIndex]?.id) + 1} of {visibleQuestions.length}
                                                                </Typography>
                                                                <Box sx={{
                                                                    width: '60px',
                                                                    height: 4,
                                                                    bgcolor: 'grey.200',
                                                                    borderRadius: 2,
                                                                    overflow: 'hidden'
                                                                }}>
                                                                    <Box sx={{
                                                                        height: '100%',
                                                                        bgcolor: surveyTheme?.accentColor || '#1976d2',
                                                                        borderRadius: 2,
                                                                        width: `${((visibleQuestions.findIndex(question => question.id === questions[currentQuestionIndex]?.id) + 1) / Math.max(visibleQuestions.length, 1)) * 100}%`,
                                                                        transition: 'width 0.3s ease'
                                                                    }} />
                                                                </Box>
                                                            </Box>
                                                        )}

                                                        {/* Next/Submit Button */}
                                                        {currentQuestionIndex === lastVisibleQuestionIndex ? (
                                                            <Button
                                                                type="button"
                                                                onClick={handleNextQuestion}
                                                                variant="contained"
                                                                endIcon={<Send />}
                                                                sx={{
                                                                    px: { xs: 2, sm: 4 },
                                                                    py: 1.5,
                                                                    bgcolor: surveyTheme?.accentColor || '#1976d2',
                                                                    borderRadius: 3,
                                                                    fontSize: '1rem',
                                                                    fontWeight: 600,
                                                                    minWidth: { xs: 'auto', sm: '140px' },
                                                                    boxShadow: `0 4px 12px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.4)}`,
                                                                    transition: 'all 0.2s ease',
                                                                    '&:hover': {
                                                                        bgcolor: darken(surveyTheme?.accentColor || '#1976d2', 0.1),
                                                                        transform: 'translateY(-2px)',
                                                                        boxShadow: `0 6px 16px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.5)}`
                                                                    }
                                                                }}
                                                            >
                                                                {isMobile ? <Send /> : 'Submit'}
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                onClick={handleNextQuestion}
                                                                endIcon={<ArrowForward />}
                                                                variant="contained"
                                                                sx={{
                                                                    px: { xs: 2, sm: 4 },
                                                                    py: 1.5,
                                                                    bgcolor: surveyTheme?.accentColor || '#1976d2',
                                                                    borderRadius: 3,
                                                                    fontSize: '1rem',
                                                                    fontWeight: 600,
                                                                    minWidth: { xs: 'auto', sm: '140px' },
                                                                    boxShadow: `0 4px 12px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.4)}`,
                                                                    transition: 'all 0.2s ease',
                                                                    '&:hover': {
                                                                        bgcolor: darken(surveyTheme?.accentColor || '#1976d2', 0.1),
                                                                        transform: 'translateY(-2px)',
                                                                        boxShadow: `0 6px 16px ${alpha(surveyTheme?.accentColor || '#1976d2', 0.5)}`
                                                                    }
                                                                }}
                                                            >
                                                                {isMobile ? <ArrowForward /> : 'Next'}
                                                            </Button>
                                                        )}
                                                    </Box>
                                                </Container>
                                            </Box>
                                        </>
                                        )
                                ) : (
                                    <Typography>No questions available</Typography>
                                )}
                            </form>
                        </Paper>)}

                        <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
                            <Alert severity="error" onClose={() => setError(null)}>
                                {error}
                            </Alert>
                        </Snackbar>
                    </Container>
                )}
            </Box>
        </LocalizationProvider>
    );
}

// Universal parser for multiple choice options
const getMultipleChoiceOptions = (question) => {
    if (Array.isArray(question.options) && question.options.length > 0) {
        return question.options;
    }
    // Use choices if options is empty but choices exists
    if (question.choices && Array.isArray(question.choices) && question.choices.length > 0) {
        return question.choices;
    }

    return [];
};

// Fisher-Yates shuffle algorithm for randomizing options
const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

// Get randomized options for question types that support randomization
const getRandomizedOptions = (question) => {
    const baseOptions = getMultipleChoiceOptions(question);
    
    // Check if randomization is enabled for this question
    if (question.randomize && ['dropdown', 'multiple-choice', 'checkboxes'].includes(question.type)) {
        // Special handling for "Other" option - always keep it at the end
        const otherIndex = baseOptions.findIndex(option => 
            typeof option === 'string' && option.toLowerCase() === 'other'
        );
        
        if (otherIndex !== -1) {
            // Remove "Other" option temporarily
            const optionsWithoutOther = baseOptions.filter((_, index) => index !== otherIndex);
            const otherOption = baseOptions[otherIndex];
            
            // Randomize options without "Other", then add "Other" back at the end
            return [...shuffleArray(optionsWithoutOther), otherOption];
        } else {
            // No "Other" option, randomize all options
            return shuffleArray(baseOptions);
        }
    }
    
    // Return original order if randomization is not enabled
    return baseOptions;
};

export default SurveyForm;
